export const AUTOMATION_ENV = false; //by HiralK for atuomation on 11-09-2025
export const IS_CACHE = true;
export const GRID_SELECT_TYPE = {
    SELECT: 'select',
    DESELECT: 'deselect'
};
export const EDIS_FIT_CELL_CONTENT = "edis";

export const GRID_ROW_SELECTION_TYPE = {
    SINGLE_ROW: 'singleRow',
    MULTI_ROW: 'multiRow'
};

export const DEFAULT_PAGE_SIZE = {
    ORDER_MESSAGES_PAGE_SIZE: 25,
    BROKER_MESSAGES_PAGE_SIZE: 25,
    EXCHANGE_MESSAGES_PAGE_SIZE: 25
};


export const GLOBAL_FUNCTION_TYPES = {
    SCROLLING_OPTION_CHAIN: 'SCROLLING_OPTION_CHAIN',
    EXPANDING_MARKET_OVERVIEW: 'EXPANDING_MARKET_OVERVIEW',
    COLLASPSING_MARKET_OVERVIEW: 'COLLASPSING_MARKET_OVERVIEW',
    EXPANDING_SIDETRAY: 'EXPANDING_SIDETRAY',
    CLOSING_SIDETRAY: 'CLOSING_SIDETRAY',
    CLOSING_OPTION_CHAIN: 'CLOSING_OPTION_CHAIN',
    USER_LOGOUT: 'USER_LOGOUT',
    OPENING_BROKERAGE_FROM_SIDE_SPREAD: 'OPENING_BROKERAGE_FROM_SIDE_SPREAD'
};

export const DASHBOARD_SUBNAV_MENUS = {
    SCREENER: 'screener',
    SUMMARY: 'summary',
    INDICES: 'indices',
    RECOMMENDATION: 'recommendation',
    INVESTMENTS: 'investments',
    LIVEPULSE: 'livePulse',
    NEWS_EVENTS: 'newsEvents',
    TRADES_LAB: 'tradersLab'//Azeem K : 19-11-2025 : BREEZE-16787 -  Breeze - Integration of Modern Algo
};

export const FINANCIAL_COLUMN = [
    "Year",
    "EPS (Rs.)",
    "P/E",
    "PEG",
    "Dividend Yield (%)",
    "Current Ratio",
    "Debt Equity Ratio",
    "Ebitda Growth (%)",
    "Pat Growth (%)",
    "Net Sales Growth (%)",
    "Quick Ratio"
];

export const MARKET_OVER_VIEW_TAB_KEYS = {
    FUTURES: 'futures',
    EVENTS: 'events',
    OVERVIEW: 'overview',
    RECOMMENDATIONS: 'recommendations',
    ANALYSIS: 'analysis',
    OPTION_CHAIN: 'option_chain',
    CONTRACT_DETAILS: 'contract_details',
    CONSTITUENTS: 'constituents',
    CHART: 'chart',
    COMPANY_INFO: 'company_info'
};
const AXIOS = {
    TIMEOUT: 40000
};

const LOGIN_CONSTANTS = {
    MPIN_LENGTH: 4,
    OTP_LENGTH: 6,
    TOTP_LENGTH: 6,
    LOGIN_USERID_LENGTH: 10,
    LOGIN_PASSWORD_MIN_LENGTH: 6,
    LOGIN_PASSWORD_MAX_LENGTH: 12,
    MOBILE_NUMBER_LENGTH: 10,
    RESEND_OTP_LIMIT: 3,
    CHIEF_TENANT_ID: 0,
    JTENANTTOKEN:1,
};
{/* Ravi R : 05-08-2025 : BREEZE-9399 - Auto lock feature in Breeze - AutoLock time range: Start */ }
const AUTO_LOCK_TIME = {
    MIN_TIME: 1,
    MAX_TIME: 60
};
{/* Ravi R : 05-08-2025 : BREEZE-9399 - Auto lock feature in Breeze - AutoLock time range : Start */ }
const LOGIN_ERROR_MSG = {
    INCORRECT_USER_ID: 'Incorrect User Id or Password.',
    INCORRECT_PAN: 'Incorrect PAN or DOB, Please try again.',
    CONFIRM_MPIN_ERR: 'Confirm MPIN should be same as New MPIN.',
    CONFIRM_PASSWORD_ERR: 'Your new password and confirm password does not match.',
    INCORRECT_OTP: 'Incorrect OTP. Please try again.',
    NETWORK_ERROR: "Oops something went wrong, Kindly check internet connection.",
    AUTH_SERVICE_DOWN: "Server is being initialized. Please try again after sometime",// BT-95890 -Mahesh S -  first time user login - code added for auth service down msg
};

const RECOMMENDATION_TABS = {
    SINGLE_SCRIP: 'single scrip',
    BASKETS: 'baskets'
};

const ORDER_ENTRY_CONSTANTS = {
    CAP_PRICE_LENGTH: 6,
    CAP_PRICE_MAX_RANGE: 999999,
    QUANTITY_LENGTH: 8,
    //Maaz A : 24-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSE FO Bug Fixes - Start
    AMOUNT_LENGTH: 10,
    AMOUNT_MAX_RANGE: 9999999999,
    QUANTITY_MAX_RANGE: 99999999,
    //Maaz A : 07-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - Added max ranges for price fields - End
    PRICE_LENGTH: 13,
    //Maaz A : 24-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSE FO Bug Fixes - End
    PRICE_MAX_RANGE: 9999999999999,
    DISC_QUANTITY_MAX_RANGE: 1,
    PROTECTION_PERCENTAGE_LENGTH: 5,
    PROTECTION_PERCENTAGE_MAX_RANGE: 99.99,
    //Maaz A : 07-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - Added max ranges for price fields - End
    NUMBER_OF_INSTALLMENT_LENGTH: 3,
    NUMBER_OF_INSTALLMENT_MAX_RANGE: 999,
};

const MAX_WATCHLISTS = 10;
const MIN_SCRIPS_IN_WATCHLISTS = 1;
const MAX_SCRIPS_IN_WATCHLISTS = 50;

// Maaz A : 27-02-2023 : BT-96728 - Breeze - Global Search Feature - Start
const GLOBAL_SEARCH_MIN_LENGTH = 3;
const MAX_SEARCH_SCRIP_PER_PAGE = 25;
/* BT-118877 Breeze - Mutual Fund-Global Search : Vinit R : 21/10/2023 - Start */
const MAX_SEARCH_MF_SCRIP_PER_PAGE = 5;
/* BT-118877 Breeze - Mutual Fund-Global Search : Vinit R : 21/10/2023 - End */
const INLINE_SEARCH_MAX_SEARCH_SCRIP_PER_PAGE = 25;//ManasaB : 30/11/2023 : BT-115296 Calculator Bug Fixing
// Maaz A : 27-02-2023 : BT-96728 - Breeze - Global Search Feature - End
//BT-96728 - Global Search Feature : ManasaB : 20/07/2023 - Start
const RECENT_SEARCH_LENGTH = 5;
const EXPAND_RECENT_SEARCH_LENGTH = 10;
//BT-96728 - Global Search Feature : ManasaB : 20/07/2023 - End
const TOAST_TIMER = 2000;
const GUEST_MODE_TRIAL_DAYS = 15;
const SPECIAL_PREOPEN = 12;

const DONT_MISS_WATCHLIST_NAME = 'dontmiss';
const MY_HOLDINGS_WATCHLIST_NAME = 'myholdings';
const EDIS_SEARCH_ID = 'edis_scrips_header_search';
const WATCHLIST_SEARCH_ID = 'watchlist_header_search';
const CRORE = 'Cr.';

//Deepti B.: BT 144474 added PGQS mode
const NetNetPGQSMode = 1;

// Deepti B: 11/07/2024 : Added alert version number
const ALERT_VERSION = 'v2';

const CALL_AUCTION = {
    PRICEQUOTFACTOR: '5',
    SPOSTYPE: '12'
};
const GLOBAL_SEARCH_SCRIPS = {
    TOTAL_EQ_SCRIPS: 0,
    TOTAL_FUT_SCRIPS: '',
    TOTAL_OPT_SCRIPS: ''
};
const EXCHANGE_NAME_SCREENERS = {
    NSE_INDEX: 'NSE Index',
    NSE_SECTOR: 'NSE Sector',
    BSE_INDEX: 'BSE Index',
    BSE_SECTOR: 'BSE Sector',
    NSE: 'NSE',
    BSE: 'BSE',
    NSECDS: 'NSECDS',
    BSECDS: 'BSECDS',
    MCX: 'MCX',
    NCDEX: 'NCDEX',
    NSECOMM: 'NSE COMM',
    ICEX: 'ICEX',
    BSECOMM: 'BSE COMM',
    MSE: 'MSE'
};
const GSMVALUE = {
    GSM1: '99',
    GSM2: "0",
    GSM3: '100'
};



const API_ENCRYPTION_METHODS = {
    AES: 'AES',
    TDES: 'TDES',
    NONE: null
};

const DEFAULT_APP_EKYC_INFO = {
    ekycurl: "https://www.google.co.in/",
    ekyctext: "You want to re-activate your account?",
    ekyctitle: "Re-Activating your account",
    closuretitle: "Closing your trading account!!!",
    openmode: "0",
    openmodeios: "2"
};

//PrachiTawde : 10-05-2023 : BT-107252 -  Breeze – Rate us & Feedback - Start
const APP_INFO_PARAMS = {
    APP_FEEDBACK_MAIL: "APP_FEEDBACK_MAIL",
    APP_BROKERAGE_MODE: "APP_BROKERAGE_MODE",
    APP_GUEST_MODE_TRIAL_DAYS: "APP_GUEST_MODE_TRIAL_DAYS",
    APP_EKYC_INFO: "APP_EKYC_INFO",
    APP_CDN_BASE_PATH: "APP_CDN_BASE_PATH",
    APP_OTP_INVALID_ATTEMPT_COUNT: "APP_OTP_INVALID_ATTEMPT_COUNT",
    APP_OTPTIMER: "APP_OTPTIMER",
    APP_IOS_APP_ID: "APP_IOS_APP_ID",
    APP_WATCHLIST_SCRIP_COUNT: "APP_WATCHLIST_SCRIP_COUNT",
    APP_QR_LOGIN_TIMER: "APP_QR_LOGIN_TIMER",
    MAX_USER_DETAILS_LIST: "MAX_USER_DETAILS_LIST",
    APP_MAX_PROFILE_COUNT: 'APP_MAX_PROFILE_COUNT',
    APP_HIDE_PROFILE_UPDATE: "APP_HIDE_PROFILE_UPDATE",
    APP_PROFILE_UPDATE_CONTENT: "APP_PROFILE_UPDATE_CONTENT",
    APP_DOWNLOAD_KYC_URL: "APP_DOWNLOAD_KYC_URL",
    APP_DONTMISS_REFRESH_TIMER: 'APP_DONTMISS_REFRESH_TIMER',
    APP_PORTFOLIO_ANALYZER: "APP_PORTFOLIO_ANALYZER",
    APP_AVG_BUY_PRICE: "APP_AVG_BUY_PRICE",
    //BT-112978 Using Chart key constants from AppInfo + testing  : Displaying chart by using chart constants : Manasa B : 10/07/2023 - Start
    APP_CHART_ADVANCE_STYLE: "APP_CHART_ADVANCE_STYLE",
    APP_CHART_API_KEY: "APP_CHART_API_KEY",
    APP_CHART_BROADCAST: "APP_CHART_BROADCAST",
    APP_CHART_DATA_INTERVAL: "APP_CHART_DATA_INTERVAL",
    APP_CHART_TIME_INTERVAL: "APP_CHART_TIME_INTERVAL",
    APP_CHART_URL: "APP_CHART_URL",
    APP_MULTI_CHART: "APP_MULTI_CHART",
    //BT-112978 Using Chart key constants from AppInfo + testing  : Displaying chart by using chart constants : Manasa B : 10/07/2023 - End
    APP_HOTPURSUIT_SCRIP_COUNT: "APP_HOTPURSUIT_SCRIP_COUNT",
    //Maaz A : 15-06-2023 : BT-102298 - Breeze - Single Scrip Order entry - Start
    APP_QTY_AUTOFILL: 'APP_QTY_AUTOFILL',
    APP_PRICE_QTY_DEFAULT_VALUE: 'APP_PRICE_QTY_DEFAULT_VALUE',
    APP_DEFAULT_PRODUCT: 'APP_DEFAULT_PRODUCT',
    APP_BANNED_SCRIP_MESSAGE: 'APP_BANNED_SCRIP_MESSAGE',
    APP_REGISTER_LINK: 'APP_REGISTER_LINK',
    APP_T2T_SERIES_LIST: 'APP_T2T_SERIES_LIST',
    APP_T2T_SCRIP_ERROR_MESSAGE: 'APP_T2T_SCRIP_ERROR_MESSAGE',
    APP_AMO_MODE: 'APP_AMO_MODE',
    //Maaz A : 15-06-2023 : BT-102298 - Breeze - Single Scrip Order entry - End
    APP_SHOW_IPO: "APP_SHOW_IPO",
    APP_IPO_LINK: "APP_IPO_LINK",
    //HiralK : 01-08-2023 : Client Facility Template - Start
    APP_ORDERCART: "APP_ORDERCART",
    APP_USE_MULTILEG_API: "APP_USE_MULTILEG_API", //BREEZE-5912 : Order Cart for Derivative segment : ManasaB : 28-04-2025
    APP_ORDERCART_ORDER_COUNT: "APP_ORDERCART_ORDER_COUNT",//BT-106965 : Ordercart : SAT1 Issues : ManasaB : 02-04-2024
    APP_GSM_GRADE_CATEGORY: 'APP_GSM_GRADE_CATEGORY',//BT-106965 : Ordercart : Security Measures Warning : ManasaB : 24-04-2024
    APP_SHOW_EQSIP: "APP_SHOW_EQSIP",
    APP_SHOW_MF: "APP_SHOW_MF",
    APP_SHOW_ALERT: "APP_SHOW_ALERT",
    //HiralK : 01-08-2023 : Client Facility Template - End
    APP_REGISTER_USER_LANDING_PAGE: 'APP_REGISTER_USER_LANDING_PAGE',
    APP_GUEST_USER_LANDING_PAGE: "APP_GUEST_USER_LANDING_PAGE",
    APP_REGISTER_USERLANDINGPAGE_BREEZE: "APP_REGISTER_USERLANDINGPAGE_BREEZE",
    APP_WATCHLIST_ADDSCRIP_FOCUS: 'APP_WATCHLIST_ADDSCRIP_FOCUS',
    // Ameersha N : 17-11-2023 : BT-116461 Breeze - Addendum and Notices - Start
    APP_ADDENDUM_NOTICE: 'APP_ADDENDUM_NOTICE',
    // Ameersha N : 17-11-2023 : BT-116461 Breeze - Addendum and Notices -End
    //AmeershaN:Breeze-Addendum Notices - End
    // Hari k:08-09-2023 : contact info
    APP_CONTACTUS: "APP_CONTACTUS",
    APP_CMOT_MODE: 'APP_CMOT_MODE',
    APP_USAGE_GUIDE: "APP_USAGE_GUIDE",
    APP_NAME: 'APP_NAME',
    APP_FAQ_URLS: 'APP_FAQ_URLS',
    //Mahesh S:16-10-23:Login Edge Cases
    APP_EBUZZ_MODE: 'APP_EBUZZ_MODE',
    APP_BYPASS_TOTP: 'APP_BYPASS_TOTP',
    // Ajitesh : 20/11/2023: BT-109135: Breeze eDIS implementation - Start
    APP_MULTI_ISIN_NSDL: "APP_MULTI_ISIN_NSDL",
    APP_EDIS_REQUEST_NEWNETNET_URL: "APP_EDIS_REQUEST_NEWNETNET_URL",
    // Ajitesh : 20/11/2023: BT-109135: Breeze eDIS implementation - End
    // Hari K:10-11-2023:BT-119138: funds-start
    FUNDS_WITHDRAW: 'FUNDS_WITHDRAW',
    FUNDS_TRANSFER: 'FUNDS_TRANSFER',
    APP_NEFT_CONFIG: 'APP_NEFT_CONFIG',
    APP_FUND_MAX_AMT: 'APP_FUND_MAX_AMT',
    APP_FUNDS_WITHDRAWAL_URL: 'APP_FUNDS_WITHDRAWAL_URL',
    APP_FUNDS_CONFIG: 'APP_FUNDS_CONFIG',
    APP_UPI_INTENT_RAZORPAY: 'APP_UPI_INTENT_RAZORPAY',
    APP_NETNET_PG_URL: 'APP_NETNET_PG_URL',
    APP_NETNET_URL: 'APP_NETNET_URL',
    APP_ATOM_MINIMUM_AMOUNT: 'APP_ATOM_MINIMUM_AMOUNT',
    APP_RESERVE_BLOCK_FROM_ALLOCATION_FUND_SETTINGS_ABSOLUTE: 'APP_RESERVE_BLOCK_FROM_ALLOCATION_FUND_SETTINGS_ABSOLUTE',
    APP_WAVE_SETTING: 'APP_WAVE_SETTING',
    FUNDS_WITHDRAW_SUCCESS: 'FUNDS_WITHDRAW_SUCCESS',
    FUNDS_ADD: 'FUNDS_ADD',
    // Hari K:10-11-2023:BT-119138: funds-end

    //Maaz A : 17-11-2023 : Client Facility Template - Added for MultiLeg and Spread - Start
    APP_SHOW_MULTILEGORDER: 'APP_SHOW_MULTILEGORDER',
    //Maaz A : 17-11-2023 : Client Facility Template - Added for MultiLeg and Spread - End
    // Mahesh S : 27-11-2023 : BT-95890 first time login – to show guest flag  – Start
    APP_GUEST_MODE: 'APP_GUEST_MODE',
    // Mahesh S : 27-11-2023 : BT-95890 first time login – to show guest flag  – End
    // Azeem K : 19-12-2023 :BT-102298 :NSEEQ Holdings  – Start
    APP_AVG_PRICE_DISCLAIMER: 'APP_AVG_PRICE_DISCLAIMER',
    // Azeem K : 19-12-2023 :BT-102298 :NSEEQ Holdings  – End
    // Ajitesh : 02/01/2024: BT-109135: Breeze eDIS implementation first login param - Start
    APP_FIRST_LOGIN_OF_DAY: "APP_FIRST_LOGIN_OF_DAY",
    // Ajitesh : 02/01/2024: BT-109135: Breeze eDIS implementation first login param - End
    // Shuaib : 21/02/2024: Reconnection attempts - Start
    APP_SOCKET_RECONNECTION_RETRY_COUNT: 'APP_SOCKET_RECONNECTION_RETRY_COUNT',
    // Shuaib : 21/02/2024: Reconnection attempts - End
    APP_NESPER_ALERT: 'APP_NESPER_ALERT',
    APP_DISABLE_CLOSE_PRICE: 'APP_DISABLE_CLOSE_PRICE', //Ameersha N : 19-04-2023 - Breeze -APP-DISABLE-CLOSE-PRICE
    // Ajitesh - 30/04 flag for api cover
    APP_API_TRANSFORM_FLAG: "APP_API_TRANSFORM_FLAG",
    APP_BREEZE_VERSION: "APP_BREEZE_VERSION", // Parshva S: 30/04/2024 : Added app version number
    APP_DEV_TOOLS_MSG: "APP_DEV_TOOLS_MSG", //Ameersha N : Key for devtools msg from app info
    APP_VOLUNTARY_BLOCKING: "APP_VOLUNTARY_BLOCKING", //Deepti B[30/09/2024] : key for voluntary block online access
    APP_PASSWORD_MIN_LENGTH: "APP_PASSWORD_MIN_LENGTH", //MINIMUM PASSWORD LENGTH
    APP_AUTH_DISCLAIMER: "APP_AUTH_DISCLAIMER", //DISCLAIMER TEXT ON MPIN AND PASSWORD SCREEN
    APP_LINUX_MANAGER: "APP_LINUX_MANAGER",
    APP_BREEZE_FAQ_URL: "APP_BREEZE_FAQ_URL",// BREEZE FAQ Url
    APP_BREEZE_IS_CACHE: 'APP_BREEZE_IS_CACHE',
    APP_PLAY_STORE_LINK: "APP_PLAY_STORE_LINK",
    APP_APP_STORE_LINK: "APP_APP_STORE_LINK",
    PG_UPI_ATOM_VALUE_HEADER: "PG_UPI_ATOM_VALUE_HEADER",
    APP_MTF_NETNET_URL: "APP_MTF_NETNET_URL",
    APP_MTF_PREPLEDGE: "APP_MTF_PREPLEDGE",
    APP_BREEZE_GTT_SUPPORT: "APP_BREEZE_GTT_SUPPORT",// Azeem K:07-05 - 2025 : added conditionally GTT and GTD
    APP_ABOUTUS_URL: "APP_ABOUTUS_URL",
    APP_DISCLAIMER_MODE: "APP_DISCLAIMER_MODE",
    APP_SCRIPS_BATCH_COUNT: "APP_SCRIPS_BATCH_COUNT",
    APP_DISABLE_SWITCH_USER: "APP_DISABLE_SWITCH_USER",
    APP_SOCKET_IO_RECONNECTION_RETRY_COUNT: "APP_SOCKET_IO_RECONNECTION_RETRY_COUNT",
    APP_SOCKET_RECONNECTION_TIME_VALUE: "APP_SOCKET_RECONNECTION_TIME_VALUE",
    APP_IS_MULTI_TAB_LOGIN: "APP_IS_MULTI_TAB_LOGIN",
    APP_SHOW_BRANCHES: 'APP_SHOW_BRANCHES',
    APP_ENABLE_MA: 'APP_ENABLE_MA',//Azeem K : 19-11-2025 : BREEZE-16787 -  Breeze - Integration of Modern Algo
    APP_HIDE_FWBANK_SELECTION_OPTION:"APP_HIDE_FWBANK_SELECTION_OPTION",//Abhijeet v:20/02/2026 : 209096 disable bank selection in fund with drawl
};
//PrachiTawde : 10-05-2023 : BT-107252 -  Breeze – Rate us & Feedback - End

// HARI k:2011-2023:BT-119138:Funds-View-start

const FUNDS_DEFAULT_INPUT_LENGTH = {
    WITHDRAWAL_FUNDS: 13,
    ADD_FUNDS: 8,
    TRANSFER_FUNDS: 8
};
const PRODUCT_DETAILS = {
    PRODUCT_SOURCE: "WAVEAPI",
    PLEDGE_PRODUCT: "BREEZE",
    APP_WAVE_SOURCE: "APP_WAVE_SOURCE",
    DEFAULT_THEME: 'light'
};
const FUNDS = {
    MANDATE_REPORT: 'mandate report',
    REGISTER_MANDATE: 'register mandate',
    RECENT_TRANSACTIONS: 'recent transactions',
    WITHDRAWAL_FUNDS: "withdraw",
    ADD_FUNDS: 'add funds',
    TRANSFER_FUNDS: 'transfer'
};
// HARI k:2011-2023:BT-119138:Funds-View-end

const LANDING_PAGE = {
    WATCHLIST: 'watchlist',
    DASHBOARD: 'dashboard',
    PORTFOLIO: 'portfolio',
    ORDERS: 'orders',
};


const LANDING_PAGE_INDEX = {
    0: LANDING_PAGE.WATCHLIST,
    1: LANDING_PAGE.DASHBOARD,
    2: LANDING_PAGE.ORDERS,
    3: LANDING_PAGE.PORTFOLIO,
};


const PAYTM = 'PAYTM';
const PAYU = 'PAYU';
const PNBHOLD_BANKID = 'PNBHOLD';

const LOCAL_STORAGE_KEYS = {
    AUTO_LOCK_SESSIONS: 'AUTO_LOCK_SESSIONS',
    DISABLE_SWITCH_USER: 'DISABLE_SWITCH_USER',
    SOCKET_HEALTH_INFO: "SOCKET_HEALTH_INFO",
    USER_DETAILS: "USER_DETAILS",
    MPIN_ENABLE: "MPIN_ENABLE",
    NOTIFICATION_DETAILS: "NOTIFICATION_DETAILS",
    NOTIFICATION_DETAILS_BROKER: "NOTIFICATION_DETAILS_BROKER",
    OVERVIEW_CHART_DATA: "OVERVIEW_CHART_DATA",
    PROFILE_PICTURE: "PROFILE_PICTURE",
    SERVER_KEY: "SERVER_KEY",
    TRADE_POPUP: "TRADE_POPUP",
    ENV_SETTINGS: "ENV_SETTINGS",
    WATCHLIST_VIEW: "WATCHLIST_VIEW",
    HEADER_INDICES: "HEADER_INDICES",
    INDICES_FAVOURITE: "INDICES_FAVOURITE",
    PREVIOUS_SCREEN: "PREVIOUS_SCREEN",
    PUBLIC_KEY: "PUBLIC_KEY",
    EDIS_POPUP_CLOSE: "EDIS_POPUP_CLOSE",
    FAVOURITES_SCANNERS: "FAVOURITES_SCANNERS",
    LOGIN_TAB: "LOGIN_TAB",
    USER_ACTIVE_SESSION: "USER_ACTIVE_SESSION",
    FIRST_LOGIN_OF_DAY: "FIRST_LOGIN_OF_DAY",
    THEME: "THEME",
    CHART_URL_ATTRIBUTES: "CHART_URL_ATTRIBUTES",
    NOTIFICATION_DETAILS_ORDER: "NOTIFICATION_DETAILS_ORDER",
    DEVICE_INFO: "DEVICE_INFO",
    NOTIFICATION_DETAILS_EXCHANGE: "NOTIFICATION_DETAILS_EXCHANGE",
    PREFFERED_CHART: "PREFFERED_CHART",
    VERSION: "VERSION",
    HEADER: "HEADER",
    SELECTED_ROUTE: "SELECTED_ROUTE",
    ACCEPTED_NOTICES_ID: "ACCEPTED_NOTICES_ID",
    REJECTED_NOTICES_ID: "REJECTED_NOTICES_ID",
    CHECKBOX_NOTICES_ID: "CHECKBOX_NOTICES_ID",
    OPENED_WATCHLIST: "OPENED_WATCHLIST",
    ACTIVE_WATCHLIST: "ACTIVE_WATCHLIST",
    GUEST_TOAST: "GUEST_TOAST",
    IS_PASSWORD_CHANGED: "IS_PASSWORD_CHANGED",
    SELECTED_OPTION: "SELECTED_OPTION",
    GUEST_USER: "GUEST_USER",
    TRIGGER_ALERT_COUNT: "TRIGGER_ALERT_COUNT",
    GUEST_DEFAULT_TAB: 'GUEST_DEFAULT_TAB',
    USER_LOGGED_IN_TYPE: 'USER_LOGGED_IN_TYPE'
};

const SESSION_STORAGE_KEYS = {
    SEARCH_PARAMS: "SEARCH_PARAMS",
};

const API_SOURCE = {
    WEB_API: 'WEBAPI',
    WAVE_API: 'WAVEAPI',
    VERSION: '2.0.0',
    BREEZE: 'BREEZEAPI'
};

// //Mahesh S : 05-05-2023 : BT-107252 -  Breeze – Rate us & Feedback - Start

// const GOOGLE_PLAYSTORE_ID = "com.wave.dev";

// //Mahesh s: 07-05-2023 : BT-101870 -  Breeze – Login Through QR Code - End

const MARKETDEPTH_INDEX = {
    SEGMENT_ID: 0,
    TOKEN: 1,
    OPEN_PRICE: 2,
    CLOSE_PRICE: 3,
    HIGH_PRICE: 4,
    LOW_PRICE: 5,
    LIFE_TIME_HIGH: 6,
    LIFE_TIME_LOW: 7,
    AVG_TRADED_PRICE: 8,
    VOLUME: 9,
    BUY_QTY_1: 10,
    NO_OF_BUY_ORDER_1: 11,
    BUY_PRICE_1: 12,
    BUY_QTY_2: 13,
    NO_OF_BUY_ORDER_2: 14,
    BUY_PRICE_2: 15,
    BUY_QTY_3: 16,
    NO_OF_BUY_ORDER_3: 17,
    BUY_PRICE_3: 18,
    BUY_QTY_4: 19,
    NO_OF_BUY_ORDER_4: 20,
    BUY_PRICE_4: 21,
    BUY_QTY_5: 22,
    NO_OF_BUY_ORDER_5: 23,
    BUY_PRICE_5: 24,

    SELL_PRICE_1: 25,
    NO_OF_SELL_ORDER_1: 26,
    SELL_QTY_1: 27,
    SELL_PRICE_2: 28,
    NO_OF_SELL_ORDER_2: 29,
    SELL_QTY_2: 30,
    SELL_PRICE_3: 31,
    NO_OF_SELL_ORDER_3: 32,
    SELL_QTY_3: 33,
    SELL_PRICE_4: 34,
    NO_OF_SELL_ORDER_4: 35,
    SELL_QTY_4: 36,
    SELL_PRICE_5: 37,
    NO_OF_SELL_ORDER_5: 38,
    SELL_QTY_5: 39,
    TOTAL_BUY_QTY: 40,
    TOTAL_SELL_QTY: 41,
    SYMBOL: 42,
    EXCHANGE: 43,
    LAST_TRADE_PRICE: 44,
    NET_CHANGE_INDICATOR: 45,
    NET_CHANGE_FROM_PRE_CLOSE: 46,
    DAILY_PRICE_RANGE: 47,
    BUY_QTY_PERCENT_1: 48,
    BUY_QTY_PERCENT_2: 49,
    BUY_QTY_PERCENT_3: 50,
    BUY_QTY_PERCENT_4: 51,
    BUY_QTY_PERCENT_5: 52,
    SELL_QTY_PERCENT_1: 53,
    SELL_QTY_PERCENT_2: 54,
    SELL_QTY_PERCENT_3: 55,
    SELL_QTY_PERCENT_4: 56,
    SELL_QTY_PERCENT_5: 57,
};

const BEST5_INDEX = {
    SEGMENT_ID: 0,
    TOKEN: 1,
    LAST_UPDATED_TIME: 2,
    LAST_TRADE_TIME: 3,
    LAST_TRADE_PRICE: 4,
    NET_CHANGE_INDICATOR: 5,
    NET_CHANGE_FROM_PRE_CLOSE: 6,
    LAST_TRADE_QTY: 7,
    VOLUME: 8,
    AVG_TRADED_PRICE: 9,
    BUY_QTY_1: 10,
    BUY_PRICE_1: 11,
    NO_OF_BUY_ORDER_1: 12,
    BUY_QTY_2: 13,
    BUY_PRICE_2: 14,
    NO_OF_BUY_ORDER_2: 15,
    BUY_QTY_3: 16,
    BUY_PRICE_3: 17,
    NO_OF_BUY_ORDER_3: 18,
    BUY_QTY_4: 19,
    BUY_PRICE_4: 20,
    NO_OF_BUY_ORDER_4: 21,
    BUY_QTY_5: 22,
    BUY_PRICE_5: 23,
    NO_OF_BUY_ORDER_5: 24,
    SELL_QTY_1: 25,
    SELL_PRICE_1: 26,
    NO_OF_SELL_ORDER_1: 27,
    SELL_QTY_2: 28,
    SELL_PRICE_2: 29,
    NO_OF_SELL_ORDER_2: 30,
    SELL_QTY_3: 31,
    SELL_PRICE_3: 32,
    NO_OF_SELL_ORDER_3: 33,
    SELL_QTY_4: 34,
    SELL_PRICE_4: 35,
    NO_OF_SELL_ORDER_4: 36,
    SELL_QTY_5: 37,
    SELL_PRICE_5: 38,
    NO_OF_SELL_ORDER_5: 39,
    TOTAL_BUY_QTY: 40,
    TOTAL_SELL_QTY: 41,
    CLOSE_PRICE: 42,
    OPEN_PRICE: 43,
    HIGH_PRICE: 44,
    LOW_PRICE: 45,
    OPEN_INTEREST: 46,
    LIFE_TIME_HIGH: 47,
    LIFE_TIME_LOW: 48,
    EXCHANGE: 49,
    BUY_QTY_PERCENT_1: 50,
    BUY_QTY_PERCENT_2: 51,
    BUY_QTY_PERCENT_3: 52,
    BUY_QTY_PERCENT_4: 53,
    BUY_QTY_PERCENT_5: 54,
    SELL_QTY_PERCENT_1: 55,
    SELL_QTY_PERCENT_2: 56,
    SELL_QTY_PERCENT_3: 57,
    SELL_QTY_PERCENT_4: 58,
    SELL_QTY_PERCENT_5: 59,
    DAILY_PRICE_RANGE: 60,
    ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE: 61,
    BUY_PRICE_INDICATOR: 62,
    SELL_PRICE_INDICATOR: 63,
    VALUE: 64,
    OPEN_INTEREST_PERCENT: 65,
    LPPR: 66,
    APP_DISABLE_CLOSE_PRICE: 250 //Ameersha N : 19-04-2023 - Breeze -APP-DISABLE-CLOSE-PRICE
    // PB: 64,
    // PE: 65,
    // EPS: 66,
};

const BCAST_MSG_CODE = {
    SEGMENT_ID: 1,
    BUY_QTY: 2,
    SELL_QTY: 5,
    BUY_PRICE: 3,
    SELL_PRICE: 6,
    SECURITY_CODE: 7,
    LAST_TRADE_PRICE: 8,
    LAST_TRADE_QTY: 9,
    BUY_SELL: 11,
    QUANTITY: 12,
    PRICE: 14,
    NO_OF_ORDERS: 37,
    MARKET_TYPE: 38,
    NET_CHANGE_FROM_PRE_CLOSE: 54,
    VERSION: 63,
    MSG_CODE: 64,
    MSG_LEN: 65,
    MSG_TIME: 66,
    LAST_TRADE_TIME: 73,
    LAST_UPDATE_TIME: 74,
    OPEN_PRICE: 75,
    CLOSE_PRICE: 76,
    HIGH_PRICE: 77,
    LOW_PRICE: 78,
    VOLUME: 79,
    AVG_TRADED_PRICE: 80,
    TOTAL_BUY_QTY: 81,
    TOTAL_SELL_QTY: 82,
    OPEN_INTEREST: 88,
    LIFE_TIME_HIGH: 93,
    LIFE_TIME_LOW: 94,
    BEST_FIVE: 128,
    TOUCH_LINE: 209,
    APP_DISABLE_CLOSE_PRICE: 250,//Ameersha N : 19-04-2023 - Breeze -APP-DISABLE-CLOSE-PRICE
    DAILY_PRICE_RANGE: 380,
    OPEN_INTEREST_PERCENT: 465,
    TRADE_EXECUTION_RANGE: 499
};

const TL_INDEX = {
    SEGMENT_ID: 0,
    TOKEN: 1,
    LAST_UPDATED_TIME: 2,
    LAST_TRADE_TIME: 3,
    LAST_TRADE_PRICE: 4,
    NET_CHANGE_INDICATOR: 5,
    NET_CHANGE_FROM_PRE_CLOSE: 6,
    LAST_TRADE_QTY: 7,
    VOLUME: 8,
    AVG_TRADED_PRICE: 9,
    BUY_QTY: 10,
    BUY_PRICE: 11,
    SELL_QTY: 12,
    SELL_PRICE: 13,
    TOTAL_BUY_QTY: 14,
    TOTAL_SELL_QTY: 15,
    CLOSE_PRICE: 16,
    OPEN_PRICE: 17,
    HIGH_PRICE: 18,
    LOW_PRICE: 19,
    OPEN_INTEREST: 20,
    LIFE_TIME_HIGH: 21,
    LIFE_TIME_LOW: 22,
    MARKET_TYPE: 23,
    EXCHANGE: 24,
    DAILY_PRICE_RANGE: 25,
    BUY_PRICE_INDICATOR: 26,
    SELL_PRICE_INDICATOR: 27,
    ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE: 28,
    OPEN_INTEREST_PERCENT: 29,
    APP_DISABLE_CLOSE_PRICE: 30,//Ameersha N : 19-04-2023 - Breeze -APP-DISABLE-CLOSE-PRICE
    REAL_LAST_TRADE_PRICE: 31,
    REAL_ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE: 32,
    REAL_NET_CHANGE_FROM_PRE_CLOSE: 33,
    TRADE_EXECUTION_RANGE: 34

};

const MULTIPLIER = {
    DECIMAL_4: 0.0001,
    HUNDRED: 100,
    THOUSAND: 1000,
    TEN_THOUSAND: 10000,
    LAKH: 100000,
    THOUSAND_CRORES: 10000000000,
    CRORES: 10000000
};

const MARKET_SEGMENT_ID = {
    NSE_CASH: 1,
    NSE_DERIVATIVES: 2,
    BSE_CASH: 3,
    BSE_DERIVATIVES: 4,
    MCX_DERIVATIVES: 5,
    MCX_SPOT: 6,
    NCDEX_DERIVATIVES: 7,
    NCDEX_SPOT: 8,
    NSEL_DERIVATIVES: 9,
    NSEL_SPOT: 10,
    MSX_DERIVATIVES: 11,
    MSX_SPOT: 12,
    NSX_DERIVATIVES: 13,
    NSX_SPOT: 14,
    MSX_CASH: 15,
    MSX_FAO: 16,
    DSE_CASH: 17,
    NMCE_DERIVATIVES: 18,
    BSECOMM_DERIVATIVES: 18,
    UCX_DERIVATIVES: 19,
    NSECOMM_DERIVATIVES: 19,
    UCX_SPOT: 20,
    NSECOMM_SPOT: 20,
    NSE_SPOS: 20,
    DGCX_DERIVATIVES: 21,
    MSX_SPOS: 21,
    DGCX_SPOT: 22,
    BFX_DERIVATIVES: 25,
    BFX_SPOT: 26,
    GBOT_DERIVATIVES: 27,
    DFM_CASH: 31,
    ADX_CASH: 32,
    OFS_IPO_BONDS: 33,
    ICEX_DERIVATIVES: 34,
    NSE_DEBT: 36,
    MSX_FIM: 37,
    BSECDX_DERIVATIVES: 38,
    BSECDX_SPOT: 39,
    BSECOMM_SPOT: 40,
    BSE_PCA: 100,
    COMBINED_CASH: 521,
    COMBINED_FNO: 4102,
    COMBINED_CDS: 268438528,
};
const SME_IPO_MIN_LOT = {
    QIB_NIB: 3,//QIB and NIB
    OTHERS: 2//EMP/RII/IND/POL/SHA
};
const MAPPED_MARKET_SEGMENT_ID = {
    MAPPED_NSE_CASH: 1,
    MAPPED_NSE_DERIVATIVES: 2,
    MAPPED_BSE_DERIVATIVES: 4,
    MAPPED_BSE_CASH: 8,
    MAPPED_MSE_CASH: 15,
    MAPPED_MCX_DERIVATIVES: 16,
    MAPPED_MCX_SPOT: 32,
    MAPPED_NCDEX_DERIVATIVES: 64,
    MAPPED_NCDEX_SPOT: 128,
    MAPPED_NSEL_DERIVATIVES: 256,
    MAPPED_NSEL_SPOT: 257,
    MAPPED_MSX_DERIVATIVES: 1024,
    MAPPED_MSX_SPOT: 1025,
    MAPPED_MSX_CASH: 512,
    MAPPED_MSX_FAO: 4096,
    MAPPED_DSE_CASH: 8192,
    MAPPED_NMCE_DERIVATIVES: 16384,
    MAPPED_BSECOMM_DERIVATIVES: 16384,
    MAPPED_DFM_CASH: 524288,
    MAPPED_ADX_CASH: 1048576,

    MAPPED_NSX_DERIVATIVES: 2048,       //Dummy values used since exchanges are no longer i: us,
    MAPPED_NSX_SPOT: 2049,                //Dummy values used since exchanges are no longer i: us,
    MAPPED_BSECDX_DERIVATIVES: 268435456,
    MAPPED_BSECDX_SPOT: 268435457,
    MAPPED_UCX_DERIVATIVES: 32768,
    MAPPED_NSECOMM_DERIVATIVES: 32768,

    MAPPED_UCX_SPOT: 32769,
    MAPPED_DGCX_DERIVATIVES: 65536,
    MAPPED_DGCX_SPOT: 65537,
    MAPPED_BFX_DERIVATIVES: 262144,
    MAPPED_BFX_SPOT: 262145,
    MAPPED_OFS_IPO_BONDS: 536870912,
    MAPPED_GBOT_DERIVATIVES: 2097152,
    MAPPED_GBOT_SPOT: 2097153,
    //<BT-64716/BT-40448> <MF and NFO in Wave 2.0><Start>
    MAPPED_MUTUAL_FUND: 67108864,
    //<BT-64716/BT-40448> <MF and NFO in Wave 2.0><End>
    MAPPED_COMBINED_CASH: 521,
    MAPPED_COMBINED_FNO: 4102,
    MAPPED_COMBINED_CDS: 268438528,
    /**
     * Description : constant added for ICEX exchange
     */
    MAPPED_ICEX_DERIVATIVES: 8388608,
};

const EXCHANGE_NAME_API = {
    NSE_EQ_API: "NSE_EQ",
    NSE_DERV_API: "NSE_FO",
    BSE_EQ_API: "BSE_EQ",
    BSE_DERV_API: "BSE_FO",
    MSE_EQ_API: "MSE_EQ",
    MCX_DERV_API: "MCX_FO",
    MCX_SPOT_API: "MCX_SPOT",
    ICEX_DERV_API: "ICEX_FO",
    NCDEX_DERV_API: "NCDEX_FO",
    NCDEX_SPOT_API: "NCDEX_SPOT",
    MCXSX_EQ_API: "MSE_EQ",
    MCXSX_DERV_API: "MSE_FO",
    MCXSX_CURR_API: "MSE_CUR",
    MCXSX_SPOT_API: "MSE_SPOT",
    NSX_DERV_API: "NSE_CUR",
    NSX_SPOT_API: "NSECUR_SPOT",
    BSECDX_DERV_API: "BSE_CUR",
    BSECDX_SPOT_API: "BSECUR_SPOT",
    NSE_OTS_API: "NSE_OTS",
    BSE_COMM_API: "BSE_COMM",
    NSE_COMM_API: "NSE_COMM",
    BSECOMM_SPOT_API: "BSECOMM_SPOT",
    NSECOMM_SPOT_API: "NSECOMM_SPOT",
    NSEL_SPTCOM_DESC_API: "NSEL_SPTCOM",
    MUTUAL_FUND: "MUTUAL_FUND", // <MF and NFO in Breeze,
    DSE_EQUITIES_API: "DSE_EQ",
    BFX_FUTURES_API: "BFX",
    BFX_SPOT_API: "BFX_SPOT",
    DFM_EQ_API: "DFM_EQ",
    ADX_EQ_API: "ADX_EQ",
    MSX_FIM_API: "MCXSX_FIM",
    NMCE_FAO_API: "NMCE FO",
    UCX_FO_API: "UCX",
    ICEX_FUTURES_DESC: "ICEX FUTURES",
    ICEX_DERV_DESC: "ICEX DERIVATIVES",
    ICEX_FAO: "ICEX FO",
    EXCH_ICEX: "ICEX",
    COMBINED_CASH: "EQ Combined",
    COMBINED_FNO: "FNO Combined",
    COMBINED_CDS: "CDS Combined",
    IPO_DESC: 'NSE-OTS',
    MCX_FUTURES_API: "MCX_FUTURES",
    NCDEX_FUTURES_API: " NCDEX_FUTURES",
    NSE_CUR_API: "NSE_CUR",
    BSE_CUR_API: "BSE_CUR"
};

const EXCHANGE_NAME_NOTIFICATION = {
    NSE_EQ: 'NSE CASH',
    NSE_FO: 'NSE DERIVATIVE',
    BSE_EQ: 'BSE CASH',
    BSE_FO: 'BSE DERIVATIVE',
    MCX_FO: 'MCX FUTURE',
    NCDEX_FO: 'NCDEX FUTURE',
    NSEL_SPTCOM: 'NSEL SPOTCOM',
    MSE_CUR: 'MSE CURRENCY',
    MSE_EQ: 'MSE CASH',
    MSE_FO: 'MSE DERVATIVE',
    MCXSX_FIM: 'MCXSX_FIM',
    BSE_COMM: 'BSE COMM',
    // Hari K : 07-11-2023 : SAT-109371 : Message Hub – issue not showing the exchange format – Start/
    NSE_CUR: 'NSECDS',
    BSE_CUR: 'BSECDS',
    NSE_OTS: 'NSE-OTS',
    ICEX_FO: 'ICEX FUTURE',
    NSE_COMM: 'NSE COMM',
    MUTUAL_FUND: "MUTUAL_FUND",
    NSE_DERV: "NSE DERIVATIVES",
    BSE_DERV: "BSE DERIVATIVES",
    MCX_FUTURES: "MCX FUTURES",
    NCDEX_FUTURES: "NCDEX FUTURES",
    MCX_DERV: "MCX DERIVATIVES",
    NCDEX_DERV: "NCDEX DERIVATIVES",
    MCXSX_FUTURES: "MSE CURRENCY",
    MCXSX_EQUITIES: "MSE CASH",
    MCXSX_FAO: "MSE DERIVATIVES",
    NSX_FUTURES: "NSECDS",
    DSE_EQUITIES: "DSE EQUITIES",
    NMCE_FUTURES: "NMCE FUTURES",
    DGCX_FUTURES: "DGCX",
    UCX_FUTURES: "UCX FUTURES",
    BSECDX_FUTURES: "BSECDS",
    IPO: "NSE-OTS",
    DFM_EQ: "DFM CASH",
    ADX_EQ: "ADX CASH",
    MSX_FIM_EXCHANGE_TEXT: "MSE-FIM",
    DFM_EXCHANGE_TEXT: "DFM",
    ADX_EXCHANGE_TEXT: "ADX",
    NSEL_SPTCOM_DESC: "NSEL SPTCOM",
    BFX_FUTURES_DESC: "BFX",
    MUTUAL_FUND: "MUTUAL_FUND",
    MSX_FIM_API: "MCXSX FIM"
    // Hari K : 07-11-2023 : SAT-109371 : Message Hub – issue not showing the exchange format – end

};
const MARKET_STATUS = {
    OPEN: "OPEN",
    PRE_OPEN: "PRE OPEN",
    SPOS_OPEN: "SPOS OPEN",
    MATCHING_OPEN: "MATCHING OPEN",
    CLOSE: "CLOSE",
    SPOS_CLOSE: "SPOS CLOSE",
    MATCHING_CLOSE: "MATCHING CLOSE",
    PRE_OPEN_ENDED: "PRE OPEN ENDED",
    UNAVAILABLE: "UNAVAILABLE",
};
//Hari k:Breeze-7144-14-04-2025-market status - end
// Hari K : 07-11-2023 : SAT-109371 : Message Hub – variables – start
const MESSAGE_HUB_CHIPS = {
    BROKER: 'broker',
    ORDERS: 'order',
    EXCHANGES: 'exchange'
};
// Hari K : 07-11-2023 : SAT-109371 : Message Hub – variables – end



//By HiralK : 05-08-2023 - Decimal Locator Optimization - Start
// const DECIMAL_LOCATOR = {
//     NSE_EQ_DECIMAL_LOCATOR: 100,
//     BSE_EQ_DECIMAL_LOCATOR: 100,
//     NSE_FO_DECIMAL_LOCATOR: 100,
//     BSE_FO_DECIMAL_LOCATOR: 100,
//     MCX_FO_DECIMAL_LOCATOR: 100,
//     NCDEX_FO_DECIMAL_LOCATOR: 100,
//     NSE_CUR_DECIMAL_LOCATOR: 10000000,
//     BSE_CUR_DECIMAL_LOCATOR: 10000000,
//     NSE_COMM_DECIMAL_LOCATOR: 10000,

// };

//Maaz A : 30-08-2023 : BT-116689 - Breeze - Create Dynamic Menu - Start
const DASHBOARD_MENUS = {
    MY_SUMMARY: 'summary',
    INDICES: 'indices',
    SCREENER: 'screener',
    RECOMMENDATION: 'recommendation',
    INVESTMENTS: 'investments',
    LIVE_PULSE: 'livePulse',
    NEWS_EVENTS: 'newsEvents',
    TRADES_LAB: 'tradersLab',//Azeem K : 19-11-2025 : BREEZE-16787 -  Breeze - Integration of Modern Algo
};
//Maaz A : 30-08-2023 : BT-116689 - Breeze - Create Dynamic Menu - End

const DECIMAL_LOCATOR = {
    NORMAL: 100,
    CURRENCY: 10000000,
};
//By HiralK : 05-08-2023 - Decimal Locator Optimization - End

const MKT_SEGMENTID_HAVING_LOTS = [
    MARKET_SEGMENT_ID.MCX_DERIVATIVES,
    MARKET_SEGMENT_ID.NSEL_DERIVATIVES,
    MARKET_SEGMENT_ID.MSX_DERIVATIVES,
    MARKET_SEGMENT_ID.NSX_DERIVATIVES,
    MARKET_SEGMENT_ID.DGCX_DERIVATIVES,
    MARKET_SEGMENT_ID.BFX_DERIVATIVES,
    MARKET_SEGMENT_ID.UCX_DERIVATIVES,
    MARKET_SEGMENT_ID.MSX_CASH,
    MARKET_SEGMENT_ID.MSX_FAO,
    MARKET_SEGMENT_ID.BSECDX_DERIVATIVES,
    MARKET_SEGMENT_ID.ICEX_DERIVATIVES,
    MARKET_SEGMENT_ID.NSECOMM_DERIVATIVES,
    MARKET_SEGMENT_ID.BSECOMM_DERIVATIVES,
];

/*Mahesh S  : 03-08-2023 : BT-107422 -  Breeze- Positions Summary - Start*/
const DISPLAY_EXCHANGE_NAME = {
    NSE_CASH: "NSE CASH",
    NSE_DERIVATIVE: "NSE DERIVATIVES",
    NSE_EXCHANGE_TEXT: "NSE",
    BSE_EXCHANGE_TEXT: "BSE",
    MCX_EXCHANGE_TEXT: "MCX",
    NSECOMM_EXCHANGE_TEXT: "NSECOMM",
    BSECOMM_EXCHANGE_TEXT: "BSECOMM",
    NCDEX_EXCHANGE_TEXT: "NCDEX",
    NSEL_EXCHANGE_TEXT: "NSEL",
    MSX_EXCHANGE_TEXT: "MSE",
    NSX_EXCHANGE_TEXT: "NSECDS",
    NSX_SPOT_TEXT: "NSECUR_SPOT",
    BSECDX_EXCHANGE_TEXT: "BSECDS",
    DSE_EXCHANGE_TEXT: "DSE",
    NMCE_EXCHANGE_TEXT: "NMCE",
    BFX_EXCHANGE_TEXT: "BFX",
    DGCX_EXCHANGE_TEXT: "DGCX",
    UCX_EXCHANGE_TEXT: "UCX",
    OTSTXT_EXCHANGE_TEXT: "NSE-OTS",
    DFM_EXCHANGE_TEXT: "DFM",
    ADX_EXCHANGE_TEXT: "ADX",
    ICEX_EXCHANGE_TEXT: "ICEX",
    COMBINED_CASH: "EQ Combined",
    COMBINED_FNO: "FNO Combined",
    COMBINED_CDS: "CDS Combined",

};

const EXCHANGE_TYPES = {
    CONST_EQUITY: "Equity",
    CONST_EQFAO: "Equity FAO",
    CONST_CURR: "Currency",
    CONST_COMMODITY: "Commodity",
    CONST_COMBINED_EQ: "EQ Combined",
    CONST_COMBINED_DERV: "Derv Combined",
    CONST_COMBINED_CUR: "Currency Combined",

};

const GRID_CONTEXT = {
    WATCHLIST: "watchlist",
};

const POSITION_TYPES = {
    TODAYS: 'todays',
    OVERALL: 'overall',
    NET_POSITION: 'net_position'
};


/*Mahesh S  : 03-08-2023 : BT-107422 -  Breeze- Positions Summary - End*/

const VALIDITY_TYPES = {
    // BREEZE : 132 : Breeze - Introduction of GTT orders : Azeem K : 11-03-2025 -start
    NSE_EQ: ['DAY', 'IOC', 'GTT'],
    NSE_FO: ['DAY', 'IOC', 'GTT'],
    BSE_EQ: ['EOSESS', 'EOTODY', 'IOC', 'GTT'],
    BSE_FO: ['DAY', 'IOC', 'GTT'],
    // BREEZE : 132 : Breeze - Introduction of GTT orders : Azeem K : 11-03-2025 -End
    MCX_FO: ['DAY', 'IOC', 'GTD', 'GTC', 'EOS'],
    ICEX_FO: ['DAY', 'IOC'],
    NCDEX_FO: ['DAY', 'IOC', 'GTD', 'GTC'],
    // BREEZE : 132 : Breeze - Introduction of GTT orders : Azeem K : 11-03-2025 -start

    MSX_EQ: ['DAY', 'EOS', 'IOC', 'GTT'],
    MSX_FO: ['DAY', 'IOC', 'EOS', 'GTT'],
    MSX_FAO: ['DAY', 'EOS', 'IOC', 'GTT'],
    // BREEZE : 132 : Breeze - Introduction of GTT orders : Azeem K : 11-03-2025 -End
    NSEL_FO: ['DAY', 'IOC', 'EOS', 'FillOrKill'],
    NMCE_FO: ['DAY', 'GTD', 'GTC'],
    DSE_CASH: ['DAY', 'EOS', 'IOC', 'GTD', 'GTC'],
    // BREEZE : 132 : Breeze - Introduction of GTT orders : Azeem K : 11-03-2025 -start
    NSX_FO: ['DAY', 'IOC', 'GTT'],
    BSECDX_FO: ['DAY', 'IOC', 'GTT'],
    // BREEZE : 132 : Breeze - Introduction of GTT orders : Azeem K : 11-03-2025 -End
    UCX_FO: ['DAY', 'IOC', 'GTD', 'GTC'],
    BFX_FO: ['DAY', 'IOC', 'GTD', 'GTC'],
    IPO_BONDS: ['DAY'],
    DGCX_FO: ['DAY', 'IOC', 'GTD', 'GTC', 'GTT'],

};

const NETWORK_RESPONSE_STATUS = {
    SUCCESS: 200,
    BAD_REQUEST: 400,
    INTERNAL_SERVER_ERRO: 500,
    NOT_FOUND: 404
};



const FORGOT_PASSWORD_SESSION_NUMBER = {
    RESET_PASSWORD_USERINFO: 1,
    ENTER_OTP_SESSION: 2,
    CHANGE_PASSWORD: 3,

};

const FORGOT_MPIN_SESSION_NUMBER = {
    ENTER_OTP_SESSION: 1,
    CHANGE_MPIN: 2,
};

const FORGOT_USER_ID_SESSION_NUMBER = {
    RETRIEVE_USER_ID: 1,
    ENTER_OTP_SESSION: 2
};
const LOGIN_SESSION_NUMBER = {
    CHANGE_PASSWORD_SESSION: 1,
    ENTER_OTP_SESSION: 2,
    SET_MPIN_SESSION: 3,
    ENTER_TOTP_SESSION: 4,

};

//Parshva S : 20-03-2024
const COUNTS = {
    ZERO: 0,
    ONE: 1,
    TWO: 2,
    THREE: 3,
    FOUR: 4,
    FIVE: 5,
    SIX: 6,
    SEVEN: 7,
    EIGHT: 8,
    NINE: 9,
    TEN: 10,
};
//Parshva S : 20-03-2024

//HiralK : 01-08-2023 : commented as not required - Start
// const DONTMISS_CHIP_LENGTH = {
//     ONE: 1,
//     TWO: 2
// };
//HiralK : 01-08-2023 : commented as not required - End

//HiralK : 01-08-2023 : Client Facility Template - Start
const FACILITY_NUM = {
    ON: 1,
    OFF: 0,
};

const FACILITY_STR = {
    ON: "ON",
    OFF: "OFF",
};

const FACILITY_BOOL = {
    ON: "true",
    OFF: "false",
};
//HiralK : 01-08-2023 : Client Facility Template - End

// Azeem K : 02-09-2025 : BREEZE-10052 Require Segment wise position – Start
// LLD Comment : created constant for segment wise position
const NET_POSITION_SEGMENT_TYPES = {
    ALL: 'All',
    EQUITY: 'Equity',
    EQ_FNO: 'Derivative',
    COMMODITY: 'Commodity',
    CURRENCY: 'Currency'
};
// Azeem K : 02-09-2025 : BREEZE-10052 Require Segment wise position – End


const GUEST_LOGIN_SESSION_NO = {
    ENTER_PHONE_NO: 1,
    ENTER_OTP: 2
};
const API_CODES = {
    ECODE_INCORRECT_USER_ID: 'e-102',
    ECODE_SERVER_ERROR: 'e-101',
    ECODE_SUCCESS: 's-101',
    ECODE_OTP_ERROR: 'e-102',
    ECODE_QR_EXPIRED: 'e-104',
    ECODE_CHANGE_PASSWORD: 'e-9'
};

const API_RESPONSE_STATUS = {
    PENDING: 'pending',
    FAILURE: "failure",
    SUCCESS: 'success',
    ERROR: 'error'
};

const FUNDS_CONFIG_KEYS = {
    ADD_FUNDS: 'ADD_FUNDS',
    WITHDRAW_FUNDS: 'WITHDRAW_FUNDS',
    RECENT_TRANSACTIONS: 'RECENT_TRANSACTIONS',
    TRANSFER_FUNDS: 'TRANSFER_FUNDS',
    CHECK_FOR_DROPDOWN: 'CHECK_FOR_DROPDOWN'
};


const BUSINESS_LAYER_RESPONSE = {
    SUCCESS: 'SUCCESS',
    FAILURE: 'FAILURE'
};

const API_ERRORS = {
    ECODE_PWD_EXPIRED: 'e-1',
    ECODE_ACC_LOCKED: 'e-2',
    ECODE_LOGIN_NOT_ALLOWED: 'e-3',
    ECODE_UNSUCESSFUL_MPIN_FINGERPRINT_LOGIN: 'e-4',
    ECODE_MPIN_EXPIRED_RESET_MPIN: 'e-5',
    ECODE_MPIN_LOCKED_RESET_MPIN: 'e-6',
    ECODE_MPIN_EXPIRED: 'e-7',
    ECODE_INVALID_MPIN: 'e-8',
    ECODE_RESPONSE_FAILURE: 'e-9',
    ECODE_FINGERPRINT_AUTHORIZATION_FAILURE: 'e-10',
    ECODE_INCORRECT_CLIENTID_OR_PASSWORD: 'e-11',
    ECODE_INCORRECT_2FA: 'e-12',
    ECODE_REQ_BODY_VALIDATIONS: 'e-13',
    ECODE_OC_UNSUCESSFUL_LOGIN: 'e-14',
    ECODE_UNSUCESSFUL_MPIN_FINGERPRINT_INVALID_PASSWORD_LOGIN: 'e-15',
    ECODE_INCORRECT_OTP: 'e-16',
    ECODE_INCORRECT_TOTP: 'e-17',
    ECODE_ACC_SUSPENDED: 'e-19',
    ECODE_VERSION_CHECK: 'e-99',
    NO_DATA_FOUND: 'E1001',
    ECODE_NETWORK_ERROR: "ERR_NETWORK",
};

const SIDEMENU = {
    ORDER_TICKET: 'ORDER_TICKET',
    CHART: 'CHART',
    SCREENER: 'SCREENER',
    RECOMMENDATIONS: 'RECOMMENDATIONS',
    NEWS_EVENTS: 'NEWS_EVENTS',
    DONT_MISS: 'DONT_MISS',
    ORDERS_POSITIONS: 'ORDERS_POSITIONS',
    FUNDS: 'FUNDS',
    ALERTS_NOTIFICATIONS: 'ALERTS_NOTIFICATIONS',
    CALCULATORS: 'CALCULATORS',
    WRITE_SAVE_NOTES: 'WRITE_SAVE_NOTES',
    OVERVIEW: 'OVERVIEW'
};

const WATCHLIST_TABS_MENUS = {
    MANAGE_COLUMNS: '0',
    ADD_SCRIPS: '1',
    EXPORT_TO_EXCEL: '2',
    LINK_TO_EXCEL: '3',
    REMOVE_SCRIPS: '4',
    REORDER_SCRIPS: '5',
    RENAME_WATCHLIST: '6',
    SET_DEFAULT: '7',
    SHARE_WATCHLIST: '8',
    CREATE_NEW_WATCHLIST: '9',
    DELETE_WATCHLIST: '10',
    DEFAULT_VIEW: '11',
    PRICE_VOLUME_VIEW: '12',
    HEATMAP: '13',
    CONVERTTOORDERCART: '14', //BT-106965 : OrderCart : ManasaB : 19/01/2024 : Unit testing bugs resolve
    CLEAR_GRID_FILTER: '15'
};
//AzeemKhan : 17-01-2023 : BT-97769 -  Breeze - Account Registration (eKYC) - Start
const APP_INFO = {
    LIMIT: 2000,
    NEXT_TOKEN: null,
    LAST_SYNC: 0

};

//AzeemKhan : 17-01-2023 : BT-97769 -  Breeze - Account Registration (eKYC) - End

const WATCHLIST_VIEW_MENU = {
    DEFAULT_VIEW: '0',
    PRICE_VOLUME_VIEW: '1',
    HEATMAP: '2',
};

export const MULTILEG_DATA_OPTION_INDEX = {
    LEG_NUMBER: 0,
    SEGMENT_ID: 1,
    TOKEN: 2,
    SCRIP_TYPE: 3,
    NEXPIRY_DATE: 4,
    FUT_SEGMENT_ID_TOKEN: 5,
    STRIKE_PRICE: 6,
    LTP: 7,
    LEG_PRICE: 8,
    LTP_PERCENT: 9,
    CHANGE_IN_LTP: 10,
    BUY_PRICE: 11,
    SELL_PRICE: 12,
    SELECTED_EXPIRY: 13
};

export const OPTION_CHAIN_GRID_INDEX = {
    SEGMENT_ID_TOKEN: 1,
    DELTA_CALL: 2,
    VEGA_CALL: 3,
    GAMMA_CALL: 4,
    THETA_CALL: 5,
    IV_CALL: 6,
    VOLUME_CALL: 7,
    OI_CALL: 8,
    PERCENT_CHANGE_CALL: 9,
    LTP_CALL: 10,
    STRIKE_PRICE: 11,
    LTP_PUT: 12,
    PERCENT_CHANGE_PUT: 13,
    OI_PUT: 14,
    VOLUME_PUT: 15,
    IV_PUT: 16,
    THETA_PUT: 17,
    GAMMA_PUT: 18,
    VEGA_PUT: 19,
    DELTA_PUT: 20,
    SPOT_LTP: 21,
    ID_FOR_OPTION_CHAIN_GRID: 22,
    CALL_SEGMENT_ID_TOKEN: 23,
    PUT_SEGMENT_ID_TOKE: 24,
    OPTION_CHAIN_DATA_TYPE: 25,
    CALL_NEXPIRY_DATE: 26,
    CALL_NSTRIKE_PRICE: 27,
    PUT_NEXPIRY_DATE: 28,
    PUT_NSTRIKE_PRIE: 29,
    CALL_PERCENT_CHANGE_LTP: 30,
    CALL_CHANGE_IN_LTP: 31,
    CALL_ASK_QTY: 32,
    CALL_BUY_PRICE: 33,
    CALL_SELL_PRICE: 34,
    PUT_PERCENT_CHANGE_LTP: 35,
    PUT_CHANGE_IN_LTP: 36,
    PUT_ASK_QTY: 37,
    PUT_BUY_PRICE: 38,
    PUT_SELL_PRICE: 39,
    CALL_MULTILEG_COLOR: 40,
    PUT_MULTILEG_COLOR: 41,
    INDIVIDUAL_OPTION_TYPE: 42,
    FUT_SEGMENT_ID_TOKEN: 43,
    LEG_NUMBER: 44,
    IS_CALL_DATA_PRESENT: 45,
    IS_PUT_DATA_PRESENT: 46
};


const WATCHLIST_GRID_INDEX = {
    SEGMENT_ID: 0,
    TOKEN: 1,
    SEGMENT_ID_TOKEN: 2,
    SYMBOL: 3,
    LAST_TRADE_PRICE: 4,
    LTP_PERCENT: 5,
    CHANGE_IN_LTP: 6,
    BID_PRICE: 7,
    BID_QUANTITY: 8,
    ASK_PRICE: 9,
    ASK_QTY: 10,
    HIGH: 11,
    LOW: 12,
    OPEN: 13,
    CLOSE: 14,
    VOLUME: 15,
    ATP: 16,
    DONT_MISS: 17,
    NET_CHANGE_INDICATOR: 18,
    EXCHANGE: 19,
    SERIES: 20,
    INSTRUMENT: 21,
    EXPIRYDATE: 22,
    STRIKEPRICE: 23,
    OPTIONTYPE: 24,
    DONT_MISS_WATCHLISTS: 25,
    BID_PRICE_INDICATOR: 26,
    ASK_PRICE_INDICATOR: 27,
    MAPPED_SEGMENT_ID: 28,
    DECIMAL_LOCATOR: 29,
    SECURITY_DESCRIPTION: 30,
    DECIMAL_LOCATOR_LENGTH: 31,
    ASSET_TOKEN: 32,
    DAILY_PRICE_RANGE: 33,
    PRICE_TICK: 34,
    NSPREAD: 35,
    REGULAR_LOT: 36,
    SURV_MEASURE_DESCRIPTION: 37,
    SECTOR: 38,
    DISPLAY_DESC: 39, //By HiralK : 05-08-2023 - To resolve Search Description issue
    EXCHANGE_SEGMENT: 40, // Maaz A : Adding Exchange and Series/Segment
    // example indexs made for manage columns
    HIGH_OF_THE_DAY: 41,
    LOW_OF_THE_DAY: 42,
    FIFTY_TWO_WEEK_HIGH: 43,
    FIFTY_TWO_WEEK_LOW: 44,
    RESISTANCE_ONE: 45,
    RESISTANCE_TWO: 46,
    RESISTANCE_THREE: 47,
    PIVIOT: 48,
    SUPPORT_ONE: 49,
    SUPPORT_TWO: 50,
    SUPPORT_THREE: 51,
    VALUE: 52,
    AVG_TRADED_PRICE: 53,
    TOTAL_BUY_QTY: 54,
    TOTAL_SELL_QTY: 55,
    OPEN_INTEREST: 56,
    PERCENT_OI: 57,
    LAST_UPDATED_TIME: 58,
    IN_THE_MONEY: 59,
    NET_CHANGE_IN_RUPEES: 60,
    FAIR_VALUE: 61,
    //LASTTRADEDQUANTITY: 61, //Ameersha N -- Keep this commented
    LEND_SELL_YIELD: 62,
    BORROW_BUY_YIELD: 63,
    LTP_YIELD: 64,
    HIGH_OPEN_INTEREST: 65,
    LOW_OPEN_INTEREST: 66,
    PRICE_QUOTATION_UNIT: 67,
    TENDER: 68,
    NEWS_INDICATOR: 69,
    ALERTS: 70,
    OPEN_INTREST_PREVIOUS: 71,
    BCAST_INDICATOR: 72,
    LIFE_TIME_HIGH: 73,
    LIFE_TIME_LOW: 74,
    MARKET_CAPITALIZATION: 75,
    OPENING_OPEN_INTEREST: 76,
    BASE_PRICE_FOR_FAO: 76,
    SPOT_RATE: 77,
    BUY_YIELD: 78,
    SELL_YIELD: 79,
    AVG_TRADE_YIELD: 80,
    OPEN_YIELD: 81,
    CLOSED_YIELD: 82,
    HIGH_YIELD: 83,
    LOW_YIELD: 84,
    FIFTY_TWO_WEEK_HIGH_YIELD: 85,
    FIFTY_TWO_WEEK_LOW_YIELD: 86,
    MATURITY_DATE: 87,
    TRADE_EXECUTION_RANGE: 88,
    CALLS: 89,
    ISSUE_CAPITAL_IN_LACS: 90,
    REPORTING_QTY: 91,
    ISIN_CODE: 92,
    NEAR_MONTH: 93,
    FAR_MONTH: 94,
    YESTERDAY_HIGH: 95,
    YESTERDAY_LOW: 97,
    IS_FO_EXIST: 98,
    // Ameersha N: 06-11-2023 : BT-96552 : Manage Columns – Issue - data points is missing – Start
    VOLUME_LACS: 99,
    BORROW_BUY: 100,
    CODE: 101,
    LEND_SELL: 102,
    LAST_TRADE_TIME: 103,
    LAST_TRADE_QTY: 104,
    BUY_PRICE_INDICATOR: 105,
    SELL_PRICE_INDICATOR: 106,
    ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE: 107,
    NET_CHANGE_FROM_PRE_CLOSE: 108,
    // Ameersha N: 06-11-2023 : BT-96552 : Manage Columns – Issue - data points is missing – End
    //Maaz A : 28-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - MCX Issues Fixes - Start
    PRICE_NUMERATOR: 109,
    PRICE_DENOMINATOR: 110,
    AVM_BUY_MARGIN: 111,
    AVM_SELL_MARGIN: 112,
    //Maaz A : 28-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - MCX Issues Fixes - End
    APP_DISABLE_CLOSE_PRICE: 113,//Ameersha N : 19-04-2023 - Breeze -APP-DISABLE-CLOSE-PRICE
    ASSET_SEGMENT_ID: 114,
    PREMIUM_DISCOUNT: 115,
    MAX_SINGLE_TRANSACTION_QTY: 116, //BT-135270 : Order Slicing: ManasaB : 26-06-2024
    EXPIRY_IN_MILLISEC: 117,//BREEZE-5912 : Order Cart for Derivative segment : ManasaB : 28-04-2025
    RECOMMENDED_LOT: 118,
    RECO_TRANSACTION_TYPE: 119,
    RECO_PRICE: 120,
    RECO_ORDER_TYPE: 121,
    RECO_PROD_TYPE: 122
};

const CONSTITUENTS_GRID_INDEX = {
    SEGMENT_ID: 0,
    TOKEN: 1,
    SEGMENT_ID_TOKEN: 2,
    SYMBOL: 3,
    LAST_TRADE_PRICE: 4,
    LTP_PERCENT: 5,
    CHANGE_IN_LTP: 6,
    BID_PRICE: 7,
    DON: 8,
    ASK_PRICE: 9,
    ASK_QTY: 10,
    HIGH: 11,
    LOW: 12,
    OPEN: 13,
    CLOSE: 14,
    VOLUME: 15,
    ATP: 16,
    DONT_MISS: 17,
    NET_CHANGE_INDICATOR: 18,
    EXCHANGE: 19,
    SERIES: 20,
    INSTRUMENT: 21,
    EXPIRYDATE: 22,
    STRIKEPRICE: 23,
    OPTIONTYPE: 24,
    DONT_MISS_WATCHLISTS: 25,
    BID_PRICE_INDICATOR: 26,
    ASK_PRICE_INDICATOR: 27,
    MAPPED_SEGMENT_ID: 28,
    DECIMAL_LOCATOR: 29,
    SECURITY_DESCRIPTION: 30,
    MIN_CHART: 31,
    COUNTRY: 32
};
const ALL_ORDERS_STATUS = {
    ORDER_STATUS_PENDING: 'PENDING',
    ORDER_STATUS_INPROCESS: 'INPROCESS',// BREEZE: 3416 : IPO Responsive UI: ManasaB : 29 - 11 - 2024
    ORDER_STATUS_ACTIVE: 'ACTIVE',
    ORDER_STATUS_EXECUTED: 'EXECUTED',
    // Vinit Raut : 25-01-2024 : BT-107418 - Breeze – SIP Order book -- Start
    ORDER_STATUS_RUNNING: 'RUNNING',
    ORDER_STATUS_STOPPED: 'STOPPED',
    ORDER_STATUS_DEACTIVATED: 'DEACTIVATED',
    ORDER_STATUS_PAUSED: 'PAUSED',
    // Vinit Raut : 25-01-2024 : BT-107418 - Breeze – SIP Order book -- End
    ORDER_STATUS_COMPLETED: 'COMPLETED',
    ORDER_STATUS_OMS_REJECT: "OMSREJECT",
    ORDER_STATUS_CANCELLED: 'CANCELLED',
    ORDER_STATUS_ORDERERROR: 'ORDERERROR',
    ORDER_STATUS_OMSXMITTED: 'OMSXMITTED',
    ORDER_STATUS_OMS_XMITTED: 'OMS_XMITTED',
    PARTIALLY_COMPLETED: 'PARTIALLY COMPLETED',
    ORDER_STATUS_REJECTED: 'REJECTED',
    ORDER_STATUS_ALLOCATED: 'ALLOCATED',
    ORDER_STATUS_OPEN: 'OPEN',
    ORDER_STATUS_AMOACCEPTED: 'AMOACCEPTED',
    ORDER_STATUS_WITHDRAWN: 'WITHDRAWN',
    ORDER_STATUS_MODIFIED: 'MODIFIED',
    ORDER_STATUS_ALL: 'ALL', // Hari K :12-01-2024 : BT-107431 - Breeze - Watchlist Side Tray - Orders, Positions & Holdings – NSE EQ
    AMO_ACCEPTED: 'AMO ACCEPTED',//Azeem K : 07-12-2023 :BT-101818 : Order Book - Single Scrip Order
    // ORDER_STATUS_PENDING: 'PENDING',
    ADMINPENDING: 'ADMINPENDING',
};
// Azeem K : 11-12-2023 :BT-101818 : Order Book - Single Scrip Order  ---Start
const ORDER_STATUS_FROM_RESPONSE = {
    PENDING: "PENDING",
    TRADED: "TRADED",
    CANCELLED: "CANCELLED",
    EXECUTED: "EXECUTED",
    GATEWAYREJECT: "GATEWAY REJECT",
    GATEWAYREJECT_MAIN: "GATEWAYREJECT",
    ORDERERROR: "ORDER ERROR",
    OMSXMITTED: "OMS XMITTED",
    EXCHANGEXMITTED: "EXCHANGE XMITTED",
    FROZEN: "FROZEN",
    AMO_CANCELLED: "AMO CANCELLED",
    M_PENDING: "M.PENDING",
    A_ACCEPT: "A.ACCEPT",
    A_REJECT: "A.REJECT",
    A_MODIFY: "A.MODIFY",
    A_CANCEL: "A.CANCEL",
    CLIENTXMITTED_MAIN: "CLIENTXMITTED",
    CLIENT_XMITTED: "CLIENT_XMITTED",
    CLIENTXMITTED: "CLIENT XMITTED",
    GATEWAYXMITTED_MAIN: "GATEWAYXMITTED",
    GATEWAYXMITTED: "GATEWAY XMITTED",
    GATEWAY_XMITTED: "GATEWAY_XMITTED",
    OMSXMITTED_MAIN: "OMSXMITTED",
    OMS_XMITTED: "OMS_XMITTED",
    EXCHANGEXMITTED_MAIN: "EXCHANGEXMITTED",
    EXCHANGE_XMITTED: "EXCHANGE_XMITTED",
    ADMINMODIFY: "ADMIN MODIFY",
    ADMINMODIFY_MAIN: "ADMINMODIFY",
    ADMIN_MODIFY: "ADMIN_MODIFY",
    AMOSUBMITTED_MAIN: "AMOSUBMITTED",
    AMOSUBMITTED: "AMO SUBMITTED",
    AMO_SUBMITTED: "AMO_SUBMITTED",
    AMOACCEPTED: "AMO ACCEPTED",
    AMOACCEPTED_MAIN: "AMOACCEPTED",
    AMO_ACCEPTED: "AMO_ACCEPTED",
    ADMINACCEPT: "ADMIN ACCEPT",
    ADMINACCEPT_MAIN: "ADMINACCEPT",
    ADMIN_ACCEPT: "ADMIN_ACCEPT",
    ADMINPENDING_MAIN: "ADMINPENDING",
    ADMIN_PENDING: "ADMIN_PENDING",
    ADMINPENDING: "ADMIN PENDING",
    MINIADMINPENDING: "MINIADMINPENDING",
    ADMINREJECT: "ADMIN REJECT",
    ADMINREJECT_MAIN: "ADMINREJECT",
    ADMIN_REJECT: "ADMIN_REJECT",
    OMSREJECT_MAIN: "OMSREJECT",
    OMSREJECT: "OMS REJECT",
    OMS_REJECT: "OMS_REJECT",
    REJECTED_MAIN: "REJECTED",
    ORDERERROR_MAIN: "ORDERERROR",
    ORDER_ERROR: "ORDER_ERROR",
    ORDER_DASH_ERROR: "ORDER-ERROR",
    ACTIVE: "ACTIVE",
    PAUSED: "PAUSED",
    COMPLETED: "COMPLETED",
    PARTIALLYCOMPLETED: "PARTIALLY COMPLETED",
    PARTIALLYCOMPLETED_MAIN: "PARTIALLYCOMPLETED",
    PARTIALLY_COMPLETED: "PARTIALLY_COMPLETED",
    WITHDRAWN: "WITHDRAWN",
    // BREEZE : 132 : Breeze - Introduction of GTT orders : Azeem K : 11-03-2025 -Start
    TRIGGERED: "TRIGGERED",
    EXPIRED: "EXPIRED",
    // BREEZE : 132 : Breeze - Introduction of GTT orders : Azeem K : 11-03-2025 -End
    GATEWAY_REJECT: "GATEWAY_REJECT",
    CONVERTED: 'CONVERTED'

};

const ORDER_DISPLAY_STATUS = {
    Admin_Pending: 'Admin Pending',
    Rejected: 'Rejected',
    Order_Error: 'Order-Error',
    Open: 'Open',
    Active: 'Active',
    Paused: 'Paused',
    Completed: 'Completed',
    Partially_Completed: 'Partially Completed',
    Cancelled: 'Cancelled',
    Withdrawn: 'Withdrawn',
    In_Process: 'In-Process',
    Resume: 'Resume',
    // Vinit Raut : 11-07-2024 : BT-107418 - Breeze – SIP Order book -- Start
    Stop: 'Stopped',
    // Vinit Raut : 11-07-2024 : BT-107418 - Breeze – SIP Order book -- End
    // BREEZE : 132 : Breeze - Introduction of GTT orders : Azeem K : 11-03-2025 -Start
    Triggered: 'Triggered',
    Expired: 'Expired'
    // BREEZE : 132 : Breeze - Introduction of GTT orders : Azeem K : 11-03-2025 -End
};
// Azeem K : 11-12-2023 :BT-101818 : Order Book - Single Scrip Order  ---End


const ALERT_STATUS = {
    ACTIVE: 'Active',
    TRIGGERED: 'Triggered'
};

// K Hari : 21-10-2023 NEWS CMOT_MODE-start
const NEWS_CMOT_MODE = {
    CMOT_OFF: 0,
    CMOT_LITE: 1,
    CMOT_PRO: 2
};
// K Hari : 21-10-2023 NEWS CMOT_MODE-end

const MUTUALFUND_WATCHLIST_TABS_MENUS = {
    CREATE_NEW_WATCHLIST: '0',
    REMOVE_WATCHLIST: '1',
    REORDER_WATCHLIST: '2',
    RENAME_WATCHLIST: '3',
    SHARE_WATCHLIST: '4',
    DELETE_WATCHLIST: '5'
};


const GLOBAL_SEARCH_PAGES = [
    { name: 'Dashboard', route: 'dashboard' },
    { name: 'Watchlist', route: 'watchlist' },
    { name: 'Orders', route: 'orders' },
    { name: 'Portfolio', route: 'portfolio' },
    { name: 'Funds', route: 'funds' },
];

// Maaz A : 27-02-2023 : BT-96728 - Breeze - Global Search Feature - End

const MPIN_INPUT_CLASSES = {
    NO_CLASS: 0,
    SUCCESS: 1,
    ERROR: 2,
};

const DASHBOARD_EXPLORE_CATEGORY = {
    MAIN: 1,
    MUTUAL_FUNDS: 2,
    IPO: 3,
    NFO: 4,
    INSURANCE: 5,
    NEWS: 6,
    INDICES: 7,
    LIVEPULSE: 8,
    SCREENERS: 9,
};


const ORDER_PRODUCT_TYPES = {
    MARGIN: "MARGIN",
    DELIVERY: "DELIVERY",
    MTF: "MTF",
    COVER: "COVER",
    BTST: "BTST",
    INTRADAY: "INTRADAY",
    CARRYFORWARD: "CARRYFORWARD",
    OFS: "OFS",
    BRACKET: "BRACKET",
    SIP: "SIP",
    PTST: "PTST",
    AMO_MARGIN: "AMO MARGIN",
    AMO_DELIVERY: "AMO DELIVERY",
    AMO_INTRADAY: "AMO INTRADAY",
    AMO_CARRYFORWARD: "AMO CARRYFORWARD"
};

const ORDER_PRODUCT_TYPES_VALUES = {
    MARGIN_VALUE: "M",
    DELIVERY_VALUE: "D",
    DELIVERY_CARRYFORWARD_VALUE: "D",
    MTF_VALUE: "MF",
    MP_VALUE: "MP",
    PTST_VALUE: "PT",
    BRACKET_VALUE: "B",
    AMO_MARGIN_VALUE: "AM",
    AMO_DELIVERY_VALUE: "AD",
};
const INDICES_CONSTANTS = {
    CARDS_PER_SCREEN: 6 //Prachi T - 27-11-2023 :- BT-104813 -- Dashboard Indices
};
//BT-107437: Functional Implementation InvestMents : Vaibhav Singh : 21-08-2023 : Implemented Value for Dyanamic URl
const DYANMIC_URL_CONSTANTS = {
    UID: "{{UID}}",
    HEX_UID: "{{HEXUID}}",
    SESSION: "{{SESSION}}",
    OCTOKEN: "{{OCTOKEN}}",
    USERCODE: "{{USERCODE}}",
    DEALERCODE: "{{DEALERCODE}}",
    GROUPID: "{{GROUPID}}",
    GROUPCODE: "{{GROUPCODE}}",
    MANAGERID: "{{MANAGERID}}",
    PANNO: "{{PANNO}}",
    HEX_PANNO: "{{HEXPANNO}}",
    BASE64_PANNO: "{{BASE64PANNO}}",
    EMAIL: "{{EMAIL}}",
    PAN: "{{PAN}}",
    MOBILE: "{{MOBILE}}",
    PRODUCTCODE: "{{PRODUCTCODE}}",
    USERNAME: "{{USERNAME}}",
    BASE64_UID: "{{BASE64USERID}}",
    BASE64_SESSION: "{{BASE64SESSION}}",
    BASE64_OCTOKEN: "{{BASE64OCTOKEN}}",
    BASE64_USERCODE: "{{BASE64USERCODE}}",
    BASE64_DEALERCODE: "{{BASE64DEALERCODE}}",
    BASE64_GROUPID: "{{BASE64GROUPID}}",
    BASE64_GROUPCODE: "{{BASE64GROUPCODE}}",
    BASE64_MANAGERIP: "{{BASE64MANAGERID}}",
    BASE64_EMAIL: "{{BASE64EMAIL}}",
    BASE64_MOBILE: "{{BASE64MOBILE}}",
    BASE64_PRODUCTNAME: "{{BASE64PRODUCTNAME}}",
    BASE64_PRODUCTCODE: "{{BASE64PRODUCTCODE}}",
    BASE64_USERNAME: "{{BASE64USERNAME}}",
    ENCR_UID: "{{ENCRUSERID}}",
    ENCR_SESSION: "{{ENCRSESSION}}",
    ENCR_OCTOKEN: "{{ENCROCTOKEN}}",
    ENCR_USERCODE: "{{ENCRUSERCODE}}",
    ENCR_DEALERCODE: "{{ENCRDEALERCODE}}",
    ENCR_GROUPID: "{{ENCRGROUPID}}",
    ENCR_GROUPCODE: "{{ENCRGROUPCODE}}",
    ENCR_MANAGERIP: "{{ENCRMANAGERID}}",
    ENCR_EMAIL: "{{ENCREMAIL}}",
    ENCR_PAN: "{{ENCRPAN}}",
    ENCR_MOBILE: "{{ENCRMOBILE}}",
    ENCR_PRODUCT: "{{ENCRPRODUCT}}",
    ENCR_USERNAME: "{{ENCRUSERNAME}}",
    ENCR_PRODUCTNAME: "{{ENCRPRODUCTNAME}}",
    ENCR_PRODUCTCODE: "{{ENCRPRODUCTCODE}}",
    TDES_OCTOKEN: "{{TDESOCTOKEN}}",
    THEME: "{{THEME}}",
    TITLE: "{{TITLE}}",
    MODE: "{{MODE}}",
    VERSION: "{{VERSION}}",
    VENDOR: "{{VENDOR}}",
    PRODUCTNAME: "{{PRODUCTNAME}}",
    MKTSEGID: "{{MKTSEGID}}",
    SERIES: "{{SERIES}}",
    PRODUCTTYPE: "{{PRODUCTTYPE}}",
    TRANSACTIONTYPE: "{{TRANSACTIONTYPE}}",
    QTY: "{{QTY}}",
    PRICE: "{{PRICE}}",
    BROKERAGE: "{{BROKERAGE}}",
    LEGINDICATOR: "{{LEGINDICATOR}}",
    INSTRUMENT: "{{INSTRUMENT}}",
    PRICELOCATOR: "{{PRICELOCATOR}}",
    APPLICATION: "{{APPNAME}}",
    REQUEST_TYPE: "{{REQUESTTYPE}}",
    ALIASID: "{{ALIASID}}",
    ENCR_ALIASID: "{{ENCRALIASID}}",
    BASE64_ALIASID: "{{BASE64ALIASID}}",
    KOTAK_CLIENTID: '{{kotakclientid}}',
    KOTAK_SESSIONID: '{{kotaksessionid}}',
    KOTAK_TRADINGID: '{{kotaktradingid}}',
    BASE64_ENCRYPTION: 'base64{%',
    ENCRYPTION_ENDTAG: '%}',
    NEFT_PRODUCTNAME: "{{NEFTPRODUCTNAME}}",
    URI_OCTOKEN: "{{URIOCTOKEN}}",
    PRODUCT_KEY: "Product=" // Deepti B.[22/11/2024] Bt-144474 constant for the product key to validate
};
//PrachiTawde : 08-06-2023 : BT-110222 -  Breeze- Having Problem? Share with us - Start

//PrachiTawde : 08-06-2023 : BT-110222 -  Breeze- Having Problem? Share with us - End

const WALKTHROUGH_POPOVER = {

    DASHBOARD: 3,


};

const DASHBOAR_WALKTHROUGH_POPOVER_SEQUENCE = {
    MARKET_WATCH: 1,
    GLOBAL_SEARCH: 2,
    OPEN_ORDERS: 3
};

const CONFIRMATION_TYPES = {
    SQUARED_OFF: 'Squared Off',
    CANCELLED: 'Cancelled'
};

const SIDE_TRAY_EXPAND_PERCENTAGE = {
    HUNDERED_PERCENT: '100%',
    SEVENTY_FIVE_PERCENT: '75%',
    FIFTY_PERCENT: '50%',
    TWENTY_FIVE_PERCENT: '25%',
    ZERO_PERCENT: '0%'
};
const SCRIP_INSTRUMENTS = {
    EQUITIES: "EQUITIES",
    FUTIDX: "FUTIDX",
    FUTSTK: "FUTSTK",
    FUTCUR: "FUTCUR",
    FUTCOM: 'FUTCOM',
    FUTBAS: 'FUTBAS',
    OPTFUT: 'OPTFUT',
    COMDTY: "COMDTY",
    AUCBI: "AUCBI",
    AUCTBI: 'AUCTBI',
    AUCTSI: 'AUCTSI_TEXT',
    AUCSO_TEXT: 'AUCSO_TEXT',
    FUTIVX: 'FUTIVX',
    OPTIDX: 'OPTIDX',
    OPTSTK: 'OPTSTK',
    FUTSPT_TEXT: "SPOT",
    CUR_TEXT: "CUR",
    OPTCUR_TEXT: "OPTCUR",
    //Added for BFX/DGCX
    OPTCOM_TEXT: "OPTCOM",
    FUTURES_TEXT: "FUTURES",
    OPTIONS_TEXT: "OPTIONS",

    //Added for Auction related change
    AUCBI_TEXT: "AUCBI",
    AUCTBI_TEXT: "AUCTBI",
    AUCTSI_TEXT: "AUCTSO",

    MCXFUTSPT_TEXT: "COM",
    NCDEXSPOT_TEXT: "COM",
    NCDEXCOMDTY_TEXT: "COMDTY",
    NSELSPTCOM_TEXT: "SPTCOM",
    CURRENCY_TEXT: "CURRENCY",
    UCXFUTSPT_TEXT: "COM",

    //Added for NSE CDS
    FUTIRD_TEXT: "FUTIRD",
    FUTIRT_TEXT: "FUTIRT",
    INDEX_TEXT: "INDEX",
    UNDCUR_TEXT: "UNDCUR",
    UNDIRD_TEXT: "UNDIRD",
    UNDIRT_TEXT: "UNDIRT",

    //Added for GBOT
    COMCFD_TEXT: "COMCFD",
    CURCFD_TEXT: "CURCFD",

    DGCXFUTSPT_TEXT: "COM",
    DGCXSPOT_TEXT: "SPOT",
    BFXFUTSPT_TEXT: "COM",
    FUTIRC_TEXT: "FUTIRC",
    FUTIRF_TEXT: "FUTIRF",
    FUT: "FUT",
    OPT: "OPT",
    FUTBLN: "FUTBLN",
};

//Maaz A : 15-06-2023 : BT-102298 - Breeze - Single Scrip Order entry - Start

const MSG_MASTER = {
    APP03: "New version of the app is available. Please click here to update",
    APPBANNED: "Security is in banned list, do you want to place order?",
    APPSHORTSELL: "Entered Qty is greater than Qty available in holdings. Short selling is not allowed for",
    APPT2T: "You are placing order in Trade to trade Scrip and Intraday square off is not allowed.",
    APP_GSM_GRADE_CATEGORY: "OFF",
    APP_T2T: "You are placing order in Trade to trade Scrip and Intraday square off is not allowed.",
    NNSL100: "Unable to establish Interactive socket connection",
    NNSL101: "Unable to establish Broadcast socket connection",
    NNSL16: "New password does not match confirm password",
    NNSL215: "Margin Plus order not allowed for this LTP",
    NNSL217: "TriggerPrice out of range",
    NNSL218: "Margin Plus order not allowed for selected validity",
    NNSL219: "Margin Plus Order Not allowed as underlying LTP not available",
    NNSL220: "Margin Plus order not allowed for this scrip",
    NNSL247: "Market is closed, do you want to submit the order",
    NNSL254: "Please enter Confirm Password",
    NNSL26: "Please enter Symbol",
    NNSL27: "Please enter Series",
    NNSL271: "Please enter New Password",
    NNSL28: "Expiry Date not allowed",
    NNSL280: "New Password can not be same as default password",
    NNSL29: "Strike Price not allowed",
    NNSL30: "Option Type not allowed",
    NNSL306: "cannot be less than ",
    NNSL307: "Only Regular Order is allowed in this Session",
    NNSL308: "Order for selected product type not allowed in this session",
    NNSL309: "Order not allowed for selected Validity",
    NNSL31: "Protection Percentage not allowed",
    NNSL310: "Mkt Order not allowed for in this session",
    NNSL311: "Disclosed Qty not allowed in this Session",
    NNSL312: "Disclosed Qty not allowed in Call Auction 2 Session",
    NNSL313: "Market Order not allowed in Call Auction 2 Session",
    NNSL314: "Only Day Validity is allowed in Call Auction 2 Session",
    NNSL315: "Only Regular Order is allowed in Call Auction 2 Session",
    NNSL316: "Selected Validity is not allowed in Special Pre Open Session",
    NNSL317: "Market Order not allowed in Special Pre Open Session",
    NNSL318: "Only Regular Order is allowed in Special Pre Open Session",
    NNSL32: "Series not allowed",
    NNSL33: "Please enter Expiry Date",
    NNSL34: "Strike Price not allowed",
    NNSL347: "Market Order not allowed for this scrip",
    NNSL348: "Limit Order not allowed for this scrip",
    NNSL35: "Option Type not allowed",
    NNSL351: "Protection limit should be less <= ",
    NNSL352: "Market Protection % should be <=",
    NNSL357: "{0} cannot be zero",
    NNSL358: "Please enter {0} with {1} decimal digits",
    NNSL359: "The entered {0} value is not in multiple of price tick which is",
    NNSL360: "{0} out of range",
    NNSL361: "Please enter SL Jump Price less than or equal to LTP Jump Price",
    NNSL362: "Please enter valid {0}. {0} cannot be negative",
    NNSL363: "Please enter {0} less than first order price",
    NNSL364: "Please enter {0} less than LTP",
    NNSL365: "Please enter {0} greater than first order price",
    NNSL366: "Please enter {0} greater than LT",
    NNSL368: "When you place a bracket order,you get an option to either place a fixed stop loss order",
    NNSL370: "{0} not allowed for this LTP",
    NNSL371: "{0} not allowed for selected validity",
    NNSL372: "{0} not allowed for this scrip",
    NNSL373: "{0} Not allowed as underlying LTP not available",
    NNSL374: "{0} not allowed for this Price",
    NNSL375: "Invalid modification.Please modify at least one field value",
    NNSL388: "cannot be less than 20% of",
    NNSL39: "Symbol not in correct format",
    NNSL40: "Series not in correct format",
    NNSL42: "Option Type not in correct format",
    NNSL43: "Value of days should be between 1 to 7",
    NNSL44: "Please enter ",
    NNSL45: "greater than 0",
    NNSL46: "The entered quantity is not in multiple of Market Lot which is ",
    NNSL47: "should not have decimal character",
    NNSL48: "less than or equal to total ",
    NNSL49: "Please enter valid disclosed quantity. The disclosed quantity cannot be less than 10% of quantity",
    NNSL51: "Please enter valid ",
    NNSL52: "cannot be less than 10% of ",
    NNSL53: "cannot be less than 25% of",
    NNSL54: "cannot be less than 100% of ",
    NNSL55: "not applicable for IOC Order",
    NNSL57: "The entered ",
    NNSL58: "is not in multiple of Market Lot which is ",
    NNSL59: "Please enter valid Price. Price cannot be negative",
    NNSL60: "Please enter price with four decimal digits",
    NNSL61: "Please enter price with two decimal digits",
    NNSL62: "The entered price value is not in multiple of price tick which is ",
    NNSL63: "paise!",
    NNSL65: "Trigger field cannot be left empty for SL order",
    NNSL66: "Trigger Price cannot be zero",
    NNSL67: "Please enter trigger price with four decimal digits",
    NNSL68: "Please enter trigger price with two decimal digits",
    NNSL69: "The entered trigger price value is not in multiple of price tick which is ",
    NNSL70: "Please enter trigger price greater than or equal to price for buy order",
    NNSL71: "Please enter trigger price less than or equal to price for buy order",
    NNSL72: "Please enter trigger price less than or equal to price for sell order",
    NNSL73: "Please enter trigger price greater than or equal to price for sell order",
    NNSL75: "CA order type not allowed for validity other than IOC",
    NNSL76: "Only DAY validity allowed for MarginPlus order",
    NNSL77: "Please enter days for GTD (Good till days) order",
    NNSL78: "Please enter days between 1 to 100",
    NNSL79: "Orders not allowed for COM market",
    NNSL80: "IOC not allowed for StopLoss orders",
    NNSL81: "FillOrKill not allowed for StopLoss orders",
    NNSL82: "StopLoss orders not allowed for Auction orders",
    NNSL83: "Only EOS validity allowed for Auction orders",
    NNSL84: "Only sell orders allowed for Auction Buy In",
    NNSL85: "Only buy orders allowed for Auction Sell Out",
    NNSL86: "Price cannot be 0",
    NNSL88: "MarginPlus Product type not allowed for Auction scrips",
    NNSL91: "AMO order not allowed for MTF",
    NNSL92: "AMO order not allowed for PTST",
    NNSL93: "AMO order not allowed for MarginPlus",
    NNSL98: "Socket connected successful",
    OE103: "Margin Plus first leg order is RL Market Buy Order & Second leg Order is Sell SL limit/Market order",
    OE104: "Margin Plus first leg order is RL Market Sell Order & Second leg Order is Buy SL limit/Market order",
    OE106: "Cancel on Logout(COL) means that all COL tagged orders will get cancelled due to any disconnection between Broker and Exchange.",
    OE121: "Entered Qty is greater than Original Qty in {1}.",
    OE123: "Price specified is greater than {0}, Price is not in range of LTP Based Price Band. Do you still want to continue with order price?",
    OE124: "Price specified is lesser than {0}, Price is not in range of LTP Based Price Band. Do you still want to continue with order price?",
    OE125: "Price specified is greater than {0}, Price is not in range of LTP Based Price Band. Please enter price less than or equal to {0}. Restrict upper range",
    OE126: "Price specified is lesser than {0}, Price is not in range of LTP Based Price Band. Please enter price greater than or equal to {0}. Restrict lower range",
    OE57: "Strike Price not allowed",
    OE58: "Option Type not allowe",
    OE60: "Series not allowed",
    OE61: "Expiry date required",
    OE64: "StrikePrice required",
    OE65: "OptionType require",
    OE66: "Protection Percentage % cannot be greater than 99.99",
    OTP5: "Please enter 2FA Password",
    BULKADD: "MObileadmin 2",
    BSE_PRE_TRADE_RISK_CONTROL: "Stop Loss order price range check failed. Do you still want to proceed?"
};

const ORDER_ENTRY_BUTTON_TOGGLE = {
    BUY: 0,
    SELL: 1
};

const ORDER_ENTRY_BUY_SELL_TEXT = {
    BUY: 'BUY',
    SELL: 'SELL'
};

const CAUTIONARY_TRANSACTION_TYPE = {
    BUY: 1,
    SELL: 2
};

const ORDER_ENTRY_QTY_DEFAULT_VALUES = {
    SHOW_1: 1,
    SHOW_2: 2,
    BLANK: 3
};

const ORDER_ENTRY_IS_BANNED_SCRIP_STATUS = {
    NOT_BANNED: 0
};

const ORDER_ENTRY_TYPES = {
    RL: 'RL',
    RL_MKT: 'RL-MKT',
    SL: 'SL',
    SL_MKT: 'SL-MKT'
};

const ARR_ORDER_TYPES = [ORDER_ENTRY_TYPES.RL, ORDER_ENTRY_TYPES.RL_MKT, ORDER_ENTRY_TYPES.SL, ORDER_ENTRY_TYPES.SL_MKT];
const OPTION_TYPES = {
    CE: 'CE',
    PE: 'PE'
};

const MARGIN_PARAMS_DPR_FLAG = {
    CLOSE_PRICE: 0,
    LTP: 1,
    BASE_PRICE: 2
};

const ORDER_VALIDITY = {
    IOC: "IOC",
    GTC: "GTC",
    DAY: "DAY",
    GTD: "GTD",
    EOS: "EOS",
    FOK: "FOK",
    AON: "AON",
    EOSESS: "EOSESS",
    EOTODY: "EOTODY",
    EOSTLM: "EOSTLM",
    FILL_OR_KILL: "FillOrKill",
    GTT: "GTT",
};
//Maaz A : 15-06-2023 : BT-102298 - Breeze - Single Scrip Order entry - End

const SUPPORT_RESISTANCE_VIEW = {
    SCRIP_OVERVIEW: 'SCRIP_OVERVIEW',
    ORDER_ENTRY: 'ORDER_ENTRY',
    SIDETRAY_SCRIP_OVERVIEW: 'SIDETRAY_SCRIP_OVERVIEW'
};

const DELETE_ALERT_STEP = {
    ALERT_SELECTION: 1,
    CONFIRMATION: 2,
    DONE: 3
};

const APP_AVG_BUY_PRICE = {
    ON: 'ON',
    OFF: 'OFF'
};

const ORDER_TYPES = {
    SINGLE_SCRIP: 'single_scrip',
    SPREAD: 'spread',
    BASKET: 'basket',
    MULTI_LEG: 'multi_leg',
    GOOD_TILL_DATE: 'good_till_date',
    EQUITY_SIP: 'sip',
    MULTI_SCRIP: 'multi_scrip'
};


let strSearch = null;

const setStrSearch = (params) => {
    strSearch = params;
};

const SUCCESSFULL_DELETE_ALERET_MESSAGE = {
    ACTIVE_ALERT: 'Alerts Removed Successfully!',
    TRIGGERED_ALERT: 'Alerts Removed from Log Successfully'
};

const MF_WATCHLIST_GRID_INDEX = {
    SYMBOL: 'scheme_name',
    NAV: 'nav',
    AUM: 'AUM',
    EXP_RATIO: 'EXP_RATIO',
    EXIT_LOAD: 'EXIT_LOAD',
    MIN_INVESTMENT: 'MIN_INVESTMENT',
    CAGR: 'CAGR'
};

const SIP_EXCEL_FILE_NAME = {
    fileName: 'SIP.xlsx'
};
const MARKET_MOVEMENT = {

    TIME_INTERVAL: 30,
    FILENAME: {
        fileName: 'MarketMovement.xlsx'
    }
};
// Vaibhav Singh: BT-116661: 28-08-2023: Button Implemented For Peer Comprasion
const PEER_COMPARISON = {
    FILENAME: {
        fileName: 'PeerComparison.xlsx'
    }
};
const ANNUAL_REPORT = {
    FILENAME: {
        fileName: 'AnnualReport.xlsx'
    }
};
const ORDERS_TABKEY = {
    ALL_ORDERS: 'all_orders',
    OPEN_ORDERS: 'open_orders',
    COMPLETED_ORDERS: 'completed_orders',
};

const GRID_VIEW = {
    DEFAULT_VIEW: 'Default view',
    HEAT_MAP: 'Heatmap view',
    PRICE_VOLUME_VIEW: 'Price/Volume view',
    MANAGE_COLUMNS_VIEW: 'Manage Columns', //adding key for manage coluns view
};

const RECOMMENDATIONS = {
    TOOLTIP_PIXEL: '2.125rem',
    STATUS: { ACTIVE: 'active', EXPIRED: 'expired', WITHDRAWN: 'withdrawn' }
};

const APPLICATION_TYPE = 'BREEZE';

const FREQUENCY_TYPE = {
    MONTHLY: 'MONTHLY',
    FORTHNIGHTLY: 'FORTHNIGHTLY',
    WEEKLY: 'WEEKLY',
    DAILY: 'DAILY'
};
const MONTHLY_SIP_OPTIONS = {
    DATE: "DATE"
};
// Vaibhav Singh:06-03-24: varibale for Not included scanners :Start
const NOT_INCLUDED_GROUPS = [
    "Price Based",
    "Volume Based",
    "OI Based",
    "Market Diary"
];
// Vaibhav Singh:06-03-24: varibale for Not included scanners : End
const SORT_TYPES = {
    ASC: 'asc',
    DESC: 'desc'
};

const THEME_TYPE = {
    LIGHT: 'light',
    DARK: 'dark'
};

//Prachi T - 16-11-2023 - BT-110050 - Breeze- Settings Preferences - Start
const FONT_SIZE = {
    SMALL: 'sm',
    MEDIUM: 'md',
    LARGE: 'lg'
};
//Prachi T - 16-11-2023 - BT-110050 - Breeze- Settings Preferences - End

const SET_ALERT_FIELDS = {
    FACTOR1: {

        LASTTRADEDPRICE: { value: 'Last Traded Price', id: 1 },
        BIDPRICE: { value: 'Bid Price', id: 2 },
        OFFERPRICE: { value: 'Offer Price', id: 3 },
        LASTTRADEDQUANTITY: { value: 'Last Traded Quantity', id: 4 },
        BIDQUANTITY: { value: 'Bid Quantity', id: 5 },
        OFFERQUANTITY: { value: 'Offer Quantity', id: 6 },
    }
    ,
    FACTOR2: {

        PREVIOUSCLOSE: { value: 'Previous Close', id: 1 },
        OPENPRICE: { value: 'Open Price', id: 2 },
        HIGH: { value: 'High', id: 3 },
        LOW: { value: 'Low', id: 4 },
        LIFETIMEHIGH: { value: '52 Week High/Life Time High', id: 5 },
        LIFETIMELOW: { value: '52 Week Low/Life Time Low', id: 6 },
        PREVIOUSVOLUME: { value: 'Previous Volume', id: 7 },
        USE_VALUE: { value: 'Use Value', id: 8 },

    }
};

const ALERT_CATEGORIES = {
    EQ: 'Equity',
    FAO: 'F&O'

};

//Ameersha N - 16-11-2023 :- BT-104813 -- Dashboard Indices -- Issue - Mapped market segmentId will not have WFH data normal mktsegmentid should be used --Start
const DEFAULT_FAVOURITE_INDICES = [
    '1_26000',
    '3_19000'
];
//Ameersha N - 16-11-2023 :- BT-104813 -- Dashboard Indices -- Issue - Mapped market segmentId will not have WFH data normal mktsegmentid should be used --End
const SCREENERS_TABS = {
    STRATERGY: 'strategy',
    SCANNERS: 'scanners',
    MY_FAVOURITES: 'my_favourites'
};
const ROUTES = {
    Dashboard: 'dashboard',
    Watchlist: 'watchlist',
    Portfolio: 'portfolio',
    Orders: 'orders',
    MutualFunds: 'mutualFunds',
    IPO: 'ipo',
    IPO_CMOT: 'ipoCmot',
};
const GLOBAL_SEARCH_TABS = {
    ALL: 'all',
    EQUITY: 'equity',
    FUTURES: 'futures',
    OPTIONS: 'options',
    PAGES: 'pages',
    RECOMMENDATIONS: 'recommendations',
    NEWS: 'news',
    EVENTS: 'events',
    IPO: 'ipo',
    ALERTS: 'alerts'
};

//Prachi T :BT-107377 - 17-11-2023 ScripInnfo recommendations - Start
const MARKET_OVERVIEW_TABS = {
    RECOMMENDATIONS: 'recommendations'
};
//Prachi T :BT-107377 - 17-11-2023 ScripInnfo recommendations - End

const MANAGE_COLUMNS_VIEW_TYPES = {
    WATCHLIST_VIEW_TYPE: 'WATCHLIST_VIEW_TYPE',
    ORDER_SINGLE_SCRIP_VIEW_TYPE: 'ORDER_SINGLE_SCRIP_VIEW_TYPE',
    ORDER_GOOD_TILL_DATE_VIEW_TYPE: 'ORDER_GOOD_TILL_DATE_VIEW_TYPE',
    ORDER_GOOD_TILL_TRIGGER_VIEW_TYPE: 'ORDER_GOOD_TILL_TRIGGER_VIEW_TYPE',
    ORDER_EQUITY_SIP_VIEW_TYPE: 'ORDER_EQUITY_SIP_VIEW_TYPE',
    ORDER_SPREAD_VIEW_TYPE: 'ORDER_SPREAD_VIEW_TYPE',
    ORDER_MULTI_LEG_VIEW_TYPE: 'ORDER_MULTI_LEG_VIEW_TYPE',
    NET_POSITION_VIEW_TYPE: 'NET_POSITION_VIEW_TYPE',
    HOLDINGS_VIEW_TYPE: 'HOLDINGS_VIEW_TYPE',
    CONSTITUENTS_VIEW_TYPE: 'CONSTITUENTS_VIEW_TYPE',
    FUTURES_VIEW_TYPE: 'FUTURES_VIEW_TYPE'
};
//Maaz A : 07-09-2023 : BT-107437 - Breeze - Dashboard - Investments - Start
const LINK_OPEN_MODES = {
    IFRAME: '0',
    SYSTEM: '1',
    REDIRECT: '2'
};

const CONTENT_USER_MODES = {
    REGISTER_USER: 'register',
    GUEST_USER: 'guest'
};
//Maaz A : 07-09-2023 : BT-107437 - Breeze - Dashboard - Investments - End

/**BT-109096 -- Shuaib.P OPTION_CHAIN--start*/
export const OPTION_CHAIN = {
    INDICES: 'INDICES',
    MULTI_LEG: 'MULTI_LEG',
    GLOBAL_SEARCH: 'GLOBAL_SEARCH',
    OVERVIEW: 'OVERVIEW',
    CALL: 'CALL',
    PUT: 'PUT',
    CALL_PUT: 'CALL&PUT',
    SIDE_OVERVIEW: 'SIDEOVERVIEW'
};

export const OPTION_CHAIN_DROPDOWN = {
    ALL: "ALL",
    ATM: 'ATM',
    OTM: 'OTM',
    ITM: 'ITM'
};


/**BT-109096 -- Shuaib.P OPTION_CHAIN--end*/


/*BT-109369 Breeze- Watchlist- Share Watchlist --start  */
const DEEP_LINK = 'DEEP_LINK';
/*BT-109369 Breeze- Watchlist- Share Watchlist --end  */

//Maaz A : 19-10-2023 : BT-109019 - Breeze - Mutual Funds-Watchlist - Start
const MF_MAIN_TABS = {
    EXPLORE_FUNDS: 'EXPLORE_FUNDS',
    MY_CORNER: 'MY_CORNER'
};
const MF_MY_CORNER_TABS = {
    HOLDINGS: 'HOLDINGS',
    ORDERS: 'ORDERS',
    WATCHLIST: 'WATCHLIST'
};
//Maaz A : 19-10-2023 : BT-109019 - Breeze - Mutual Funds-Watchlist - End

//Maaz A : 20-10-2023 : BT-120115 - Breeze - Order Book - Good Till Date - Start
const ORDERBOOK_API_ORDER_STATUS = {
    ALL_ORDERS: -1,
    OPEN_ORDERS: 1,
    COMPLETED_ORDERS: 2,
};
//Maaz A : 20-10-2023 : BT-120115 - Breeze - Order Book - Good Till Date - End


//AzeemKhan : 06-11-2023 : BT-108797 -  Breeze - Live pulse expanded view ---Start

// Vinit Raut : 16-11-2023 : BT-108797 -  Breeze - Live pulse expanded view -- Start
const CONTRACT_TYPES = {
    ALL: 'ALL',
    FUTURES: 'FUTURES',
    CALL_PUT_OPTIONS: 'CALL & PUT OPTION',
    CALL_OPTIONS: 'CALL OPTION',
    PUT_OPTIONS: 'PUT OPTION',
};
// Vinit Raut : 16-11-2023 : BT-108797 -  Breeze - Live pulse expanded view -- End


// {/* Vinit Raut : 09-11-2023 : BT-108797 -  Breeze - Live pulse expanded view -- Start */ }
const EXPIRY_TYPES = {
    NEAR: 1,
    NEXT: 2,
    FAR: 3,
};
// {/* Vinit Raut : 09-11-2023 : BT-108797 -  Breeze - Live pulse expanded view -- End */ }

const LIVE_PULSE_TABS = {
    EQUITY: 'EQUITY',
    DERIVATIVE: 'DERIVATIVE',
    COMMODITY: "COMMODITY",
    CURRENCY: "CURRENCY"

};
const ALL_INDICES_SECTORS = 'All';
//AzeemKhan : 06-11-2023 : BT-108797 -  Breeze - Live pulse expanded view ---End

const analysisIndices = [
    { value: "NIFTY 50", id: "1_26000" },
    { value: "SENSEX", id: "3_19000" },
    { value: "FINNIFTY", id: "1_26037" },
    { value: "BANKNIFTY", id: "1_26009" },
];

const historicRecords = 288;
const historicYears = [{ value: "1Y", id: 1 }, { value: "3Y", id: 3 }, { value: "5Y", id: 5 }];



//Shuaib P : 21-10-2023  BT-110335-Breeze-IPO-Place Bid --start

const PLACE_BID = 'Place Bid';
const MODIFY_BID = 'Modify Bid';
const MIN_LOT = "Min lot at cut-off price";
const MAX_LOT = "Max lot at cut-off price";
const MIN_LOT_VALUE = 1;
const MAX_LOT_VALUE = 6;
const CUSTOM_BID = 'Custom Bid';

//Shuaib P : 21-10-2023  BT-110335-Breeze-IPO-Place Bid --end
//BREEZE-7586 : ManasaB : 26-08-2025 : IPO Additional Changes : Start
const IPO_CATEGORY = {
    RETAIL: 'Retail',
    NON_INSTITUTIONAL_BIDDER: 'Non Institutional Bidder(NIB)',
    QUALI_INSTITUTIONAL_BUYER: 'Qualified Institutional Buyer(QIB)',
    EMPLOYEE: 'EMPLOYEE',
    SHAREHOLDER: 'Shareholder',
    POLICY_HOLDER: 'Policy Holder'

};
//BREEZE-7586 : ManasaB : 26-08-2025 : IPO Additional Changes : End
// Ajitesh : 17/11/2023: BT-109135: Breeze eDIS implementation - Start
const SEGMENT_CASH = "CASH";
const DEPOSITORY_CDSL = "CDSL";
const REVOKE_TAB = "REVOKE";
const DEPOSITORY_NSDL = "NSDL";
const EDIS_PERMISSION_MESSAGE = "Give eDIS Permission for {0} Scrip(s)";
const FIRST_LOGIN_EDIS_PERMISSION_MESSAGE_BODY = "To avoid transaction failure authorize the stocks in your holdings to complete the sell transactions for the day.";
const EDIS_REVOKE_NETNET_PAGE = "EDISRevokeRequest.aspx";
const EDIS_MODES = {
    EDIS_MODE_HAMBURGER: "hamburger",
    EDIS_MODE_SINGLE_ORDER: "singleOrder",
    EDIS_MODE_PORTFOLIO: "portfolio",
    EDIS_MODE_ORDERCART: "orderCart",
};
const EDIS_REVOKE_DESCLAIMER = "Revoke will not be allowed for any scrips which have Pending/Executed Delivery sell orders. Revoke request can be initiated only after 20 minutes of eDIS authentication.";
// Ajitesh : 17/11/2023: BT-109135: Breeze eDIS implementation - End
//ManasaB : 21/11/2023 : BT-115296 Calculator Bug Fixing - Start
const FIBONACCI_TREND = {
    UPTREND: 0,
    DOWNTREND: 1
};

const HEALTHSCORE_DESC = {
    CURRENT_RATIO: 'Current Ratio determine liquidity of the company The higher the ratio the company is in the good condition to pay off its current liabilities',
    DEBT_EQUITY_RATIO: 'DebtEquity Ratio basically determine the debt positition of the company The lower the ratio the better',
    ASSET_TURNOVER_RATIO: 'Total Asset Turnover Ratio is above its industry average is positive for the company',
    DIVIDEND_YIELD: 'Dividend yield is below of its year average dividend yield is negative for the company',
    PE: 'PE is below its Year average PE multiple is positive for the company',
    PBV: 'PBV is above its Year average PBV is negative for the company',
    EPS: 'TTM EPS is higher its  industry average EPS is positive for the company',
    EARNING_YIELD: 'Earnings yield is used to determine how much earnings may receive for the invested money The lower number is negative for the company',
    SALES_GROWTH: 'TTM sales growth is higher its Year avaerage TTM sales is positive for comapny',
    PROFIT_GROWTH: 'TTM Profit growth is below its  Year average TTM profit growth is negative for the company',
    EBITDA_GROWTH: 'TTM EBIDTA growth  is below its  Year average TTM EBIDTA growth is negative for the company',
    EBIT_GROWTH: 'TTM EBIT growth  is below its  Year average TTM EBIT growth is negative for the company',
    RONW: 'RONW is above its Year average RONW is positive for the company',
    ROCE: 'ROCE is above its Year average ROCE is positive for the company',
    FOREGIN_INSTITUTIONS: 'Foreign Institutions  is below aprox  of its previous quarter Foreign Institutions  is reflecting downgrade for the company',
    PROMOTER_PLEDGE: 'Promoter Pledge collateral to avail a loan The higher from the prior pledging this may negatively affect the sentiments'
};
const GENERATE_TPIN_TEXT = 'CDSL has just sent a new TPIN to your Registered Mobile Number and E-Mail address. This is reusable PIN and not an OTP';
const GENERATE_TPIN_FAILURE_TEXT = 'Something went wrong!';
const FIBONACCI_RETREACEEXT = {
    RETRACEMENT: 0,
    EXTENSION: 1
};
//ManasaB : 21/11/2023 : BT-115296 Calculator Bug Fixing - End

// Hari k:01-02-2024: hamburgerMenu items ID-start
const HAMBURGER_MENU_ITEM_ID = {
    NEWS: 207,
    EVENTS: 208
};
// Hari k:01-02-2024: hamburgerMenu items ID-end

// {/* Vinit Raut : 15-12-2023 : BT-108797 -  Breeze - Live pulse expanded view -- Start */ }
const EXCHANGE_NAME_LIVEPULSE = {
    NSE_EQ: 'NSE',
    BSE_EQ: 'BSE',
    MSE_EQ: 'MSE',
    NSE_FO: 'NSE',
    BSE_FO: 'BSE',
    MCX_FO: 'MCX',
    NCDEX_FO: 'NCDEX',
    BSE_COMM: 'BSECOMM',
    NSE_COMM: 'NSECOMM',
    ICEX_FO: 'ICEX',
    NSE_CUR: 'NSECDS',
    BSE_CUR: 'BSECDS',
};
// {/* Vinit Raut : 15-12-2023 : BT-108797 -  Breeze - Live pulse expanded view -- End */ }

const IPO_CODE = {
    IPO_PAYMENT_CODE_P: "P",
    IPO_PAYMENT_CODE_S: "S",
    IPO_PAYMENT_CODE_F: "F",
    IPO_PAYMENT_CODE_R: "R",
    IPO_PAYMENT_CODE_REL: "REL",
    IPO_PAYMENT_STATUS_PENDING: "Pending",
    IPO_PAYMENT_STATUS_SUCCESS: "Success",
    IPO_PAYMENT_STATUS_FAILED: "Failed",
    IPO_PAYMENT_STATUS_REJECTED: "Rejected",
    IPO_PAYMENT_STATUS_RELEASE: 'Release'
};
//ManasaB : 30-01-2025 : Start
const IPO_TYPE = {
    ONGOING: 'ONGOING',
    UPCOMING: 'UPCOMING',
    PAST: 'CLOSED'
};
const IPO_TABS = {
    ONGOINGIPO: 'ongoingIPOs',
    UPCOMINGIPO: 'upcomingIPOs',
    PASTIPO: 'pastIPOs',
    ORDERBOOK: 'orderbook'
};
const ORDERBOOK_TABS = {
    ALLBIDS: 'allBids',
    CURRENTBIDS: 'currentBids',
    PASTBIDS: 'pastBids'
};
const IPO_MODALS = {
    IPO_DETAILS_MODAL: 'IPO_DETAILS_MODAL',
    BID_DETAILS_MODAL: 'BID_DETAILS_MODAL',
    IPO_PLACEBID_MODAL: 'IPO_PLACEBID_MODAL',
    SUBCRIPTION_MODAL: 'SUBCRIPTION_MODAL',
    VIEW_PLACEBID_ORDER_MODAL: 'VIEW_PLACEBID_ORDER_MODAL',
    BID_MODIFY_MODAL: 'BID_MODIFY_MODAL',
    CANCEL_BID_MODAL: 'CANCEL_BID_MODAL',
    CONFIRM_CANCEL_MODAL: 'CONFIRM_CANCEL_MODAL',
    CONFIRM_CANCEL_MESSAGE_MODAL: 'CONFIRM_CANCEL_MESSAGE_MODAL',
    CONFIRM_PAY_MODAL: 'CONFIRM_PAY_MODAL',
    IPO_TERMS_CONDITION_MODAL: 'IPO_TERMS_CONDITION_MODAL'
};
//ManasaB : 30-01-2025 : End
// Shuaib P 07-11-2023 -- To verify if it is a production or release build
//const bIsProd = false;
// Shuaib P 07-11-2023 -- To verify if it is a production or release build


// Vaibhav Singh - 18 - 03 - 2024 - BT-110050 - Breeze- Settings Preferences Updated- Start
const SETTING_TABS = {
    THEME_COLOR: 'themeColor',
    FONT: 'font',
    ORDER_PREFERENCES: 'orderPreferences',
    APP_NOTIFICATIONS: 'appNotifications',
    SECURITY: 'security',
    TAKE_ME_TO: 'takeMeTo',
    CHART_PREFERENCES: 'chartPreferences'
};
// Vaibhav Singh - 18 - 03 - 2024 - BT - 110050 - Breeze - Settings Preferences Updated- End
const ORDERS_LIMIT_IN_API = 40; //Azeem K : 07-12-2023 :BT-101818 : Order Book - Single Scrip Order //Ameersha N - 26-11-2025 Increased Limit as for big viewportscreen scrollbar is nowtshowing for lesser limit which preverns further api call onscroll
const clsConstants = {
    C_V_NSE_CASH: 1,
    C_V_NSE_DERIVATIVES: 2,
    C_V_BSE_CASH: 3,
    C_V_BSE_DERIVATIVES: 4,
    C_V_MCX_DERIVATIVES: 5,
    C_V_MCX_SPOT: 6,
    C_V_NCDEX_DERIVATIVES: 7,
    C_V_NCDEX_SPOT: 8,
    C_V_NSEL_DERIVATIVES: 9,
    C_V_NSEL_SPOT: 10,
    C_V_MSX_DERIVATIVES: 11,
    C_V_MSX_SPOT: 12,
    C_V_MSX_CASH: 15,
    C_V_MSX_FAO: 16,
    C_V_DSE_CASH: 17,
    C_V_NMCE_DERIVATIVES: 18,
    C_V_UCX_DERIVATIVES: 19,
    C_V_UCX_SPOT: 20,
    C_V_DGCX_DERIVATIVES: 21,
    C_V_DGCX_SPOT: 22,
    C_V_BFX_DERIVATIVES: 25,
    C_V_BFX_SPOT: 26,
    C_V_GBOT_DERIVATIVES: 27,
    C_V_OFS_IPO_BONDS: 33,
    C_V_DFM_CASH: 31,
    C_V_ADX_CASH: 32,
    C_V_MSX_FIM: 37,
    C_V_NMCE_DERVIVATIVES: 18,
    C_V_NSE_DEBT: 36,
    C_V_NSE_SPOS: 20,
    C_V_BSE_PCA: 100,
    C_V_MSX_SPOS: 21,
    C_V_BSECOMM_DERIVATIVES: 18,
    C_V_NSECOMM_DERIVATIVES: 19,
    C_V_BSECOMM_SPOT: 40,
    C_V_NSECOMM_SPOT: 20,

    C_V_COMBINED_CASH: 521,
    C_V_COMBINED_FNO: 4102,
    C_V_COMBINED_CDS: 268438528,

    C_V_NSX_DERIVATIVES: 13,
    C_V_NSX_SPOT: 14,
    C_V_BSECDX_DERIVATIVES: 38,
    C_V_BSECDX_SPOT: 39,

    C_V_MAPPED_NSE_CASH: 1,
    C_V_MAPPED_NSE_DERIVATIVES: 2,
    C_V_MAPPED_BSE_DERIVATIVES: 4,
    C_V_MAPPED_BSE_CASH: 8,
    C_V_MAPPED_MCX_DERIVATIVES: 16,
    C_V_MAPPED_MCX_SPOT: 32,
    C_V_MAPPED_NCDEX_DERIVATIVES: 64,
    C_V_MAPPED_NCDEX_SPOT: 128,
    C_V_MAPPED_NSEL_DERIVATIVES: 256,
    C_V_MAPPED_NSEL_SPOT: 257,
    C_V_MAPPED_MSX_DERIVATIVES: 1024,
    C_V_MAPPED_MSX_SPOT: 1025,
    C_V_MAPPED_MSX_CASH: 512,
    C_V_MAPPED_MSX_FAO: 4096,
    C_V_MAPPED_DSE_CASH: 8192,
    C_V_MAPPED_NMCE_DERIVATIVES: 16384,
    C_V_MAPPED_BSECOMM_DERIVATIVES: 16384,
    C_V_MAPPED_DFM_CASH: 524288,
    C_V_MAPPED_ADX_CASH: 1048576,

    C_V_MAPPED_NSX_DERIVATIVES: 2048,         //Dummy values used since exchanges are no longer i: us,
    C_V_MAPPED_NSX_SPOT: 2049,                //Dummy values used since exchanges are no longer i: us,
    C_V_MAPPED_BSECDX_DERIVATIVES: 268435456,
    C_V_MAPPED_BSECDX_SPOT: 268435457,
    C_V_MAPPED_UCX_DERIVATIVES: 32768,
    C_V_MAPPED_NSECOMM_DERIVATIVES: 32768,

    C_V_MAPPED_UCX_SPOT: 32769,
    C_V_MAPPED_DGCX_DERIVATIVES: 65536,
    C_V_MAPPED_DGCX_SPOT: 65537,
    C_V_MAPPED_BFX_DERIVATIVES: 262144,
    C_V_MAPPED_BFX_SPOT: 262145,
    C_V_MAPPED_OFS_IPO_BONDS: 536870912,
    C_V_MAPPED_GBOT_DERIVATIVES: 2097152,
    C_V_MAPPED_GBOT_SPOT: 2097153,
    //<BT-64716/BT-40448> <MF and NFO in Wave 2.0><Start>
    C_V_MAPPED_MUTUAL_FUND: 67108864,
    //<BT-64716/BT-40448> <MF and NFO in Wave 2.0><End>
    C_V_MAPPED_COMBINED_CASH: 521,
    C_V_MAPPED_COMBINED_FNO: 4102,
    C_V_MAPPED_COMBINED_CDS: 268438528,

    C_V_MAPPED_ICEX_DERIVATIVES: 8388608,

    C_V_MSGCODES_TOPGAINERSLOSERSRESPONSENEW: 161,
    C_V_MSGCODES_MOSTACTIVERESPONSENEW: 162,

};
//Vaibhav Singh:15-04-24:BT-107427: Updated Keys: Start
const SCRENNERS_KEYS = {
    "PriceUp+VolumeUp": [{ field: 'nVolume', headerName: 'Volume' }, { field: 'nPrevVolumeChange', headerName: 'Prev.Vol Chng %', showColor: true }],
    "PriceUp+OIUp": [{ field: 'nOpenInterest', headerName: 'Total OI' }, { field: 'nOpenInterestChange', headerName: 'Todays OI Chng %', showColor: true }],
    "Longbuildup": [{ field: 'nOpenInterest', headerName: 'Total OI' }, { field: 'nData', headerName: 'Todays OI Chng %', showColor: true }],
    "ShortCovering": [{ field: 'nOpenInterest', headerName: 'Total OI' }, { field: 'nData', headerName: 'Todays OI Chng %', showColor: true }],
    "Open=low": [{ field: 'nLow', headerName: 'Days Low' }],
    "AboveResistance": [{ field: 'nResistance', headerName: 'Resistance Level' }],
    "3DaysRunnerPositive": [{ field: 'sData', headerName: '3 Day Price Chng%', showColor: true }],
    "GapUp": [{ field: 'nClosePrice', headerName: "Prv. Close" }, { field: 'sData', headerName: "Gap Up %", showColor: true }],
    "PriceDown+VolumeUp": [{ field: 'nVolume', headerName: 'Volume' }, { field: 'nPrevVolumeChange', headerName: 'Prev.Vol Chng %', showColor: true }],
    "PriceDown+OIup": [{ field: 'nOpenInterest', headerName: 'Total OI' }, { field: 'nOpenInterestChange', headerName: 'Todays OI Chng %', showColor: true }],
    "ShortBuildUp": [{ field: 'nOpenInterest', headerName: 'Total OI' }, { field: 'nData', headerName: 'Todays OI Chng %', showColor: true }],
    "LongUnwinding": [{ field: 'nOpenInterest', headerName: 'Total OI' }, { field: 'nData', headerName: 'Todays OI Chng %', showColor: true }],
    "Open=High": [{ field: 'nHigh', headerName: 'Days High' }],
    "BelowSupport": [{ field: 'nSupport', headerName: 'Support Level' }],
    "3DaysRunnerNegative": [{ field: 'sData', headerName: '3 Day Price Chng%', showColor: true }],
    "GapDown": [{ field: 'nClosePrice', headerName: "Prev. Close" }, { field: 'sData', headerName: "Gap Down %", showColor: true }],
    "TopGainers": [{ field: 'price', headerName: 'Price Chng', showColor: true, sign: true }, { field: 'nClose', headerName: 'Prv. Close' }],
    "TopLosers": [{ field: 'price', headerName: 'Price Chng', showColor: true, sign: true }, { field: 'nClose', headerName: 'Prv. Close' }],
    "52WeekHigh": [],
    "52WeekLow": [],
    "UpperCircuit": [{ field: 'Circuit', headerName: 'Circuit Values' }],
    "LowerCircuit": [{ field: 'Circuit', headerName: 'Circuit Values' }],
    "Premium": [{ field: 'sData', headerName: 'PREMIUM %', showColor: true }],
    "Discount": [{ field: 'sData', headerName: 'DISCOUNT %', showColor: true }],
    "Advance": [{ field: 'nVolume', headerName: 'VOLUME' }, { field: 'nPrevVolumeChange', headerName: 'Volume %', showColor: true }],
    "Decline": [{ field: 'nVolume', headerName: 'VOLUME' }, { field: 'nPrevVolumeChange', headerName: 'Volume %', showColor: true }],
    "MostActiveIndexOptions": [{ field: 'nVolume', headerName: 'Volume' }, { field: 'nPrevVolumeChange', headerName: 'Prev. Vol Chng %', showColor: true }],
    "MostActiveStockOptions": [{ field: 'nVolume', headerName: 'Volume' }, { field: 'nPrevVolumeChange', headerName: 'Prev. Vol Chng %', showColor: true }],
    "OIGainers": [{ field: 'nOpenInterest', headerName: 'OI' }, { field: 'sData', headerName: 'Todays OI Chng %', showColor: true }],
    "OILosers": [{ field: 'nOpenInterest', headerName: 'OI' }, { field: 'sData', headerName: 'Todays OI Chng %', showColor: true }],
    "PCR": [],
    "VolumeToppers": [{ field: 'nVolume', headerName: 'Volume' }, { field: 'nPrevVolumeChange', headerName: 'Prev. Vol Chng %', showColor: true }],
    "NearBookValue": [{ field: 'latbv', headerName: 'Book Value' }],
    "ForeignInstitution": [],
    "DomesticInstitution": [],
    "MutualFunds": [],
    "BulkDeals": [],
    "BlockDeals": [],
    "Merger&Acquisition": [],
    "NearUpperCircuit": [{ field: 'Circuit', headerName: 'Circuit Values' }],
    "NearLowerCircuit": [{ field: 'Circuit', headerName: 'Circuit Values' }],
};

const EQUITY_SCREENERS = [20, 28, 21, 29, 22, 30, 23, 31, 49, 50, 55, 56, 36, 37];
const EQUITY_DERV_SCREENERS = [16, 24];
const EQUITY_CUR_SCREENERS = [34, 35];
const DERV_CUR_SCREENERS = [17, 25];
const DERV_CUR_COMMODITY_SCREENERS = [18, 26, 42, 43, 44, 45, 19, 27];
const ALL_COMBINED_SCREENERS = [41, 40, 47, 38, 39, 46, 32, 33];

//Vaibhav Singh:15-04-24:BT-107427: Updated Keys: End
const CATEGORY_NAME = {
    "Retail": "Retail",
    "Non Institutional Bidder": "NIB",
    "Qualified Institutional Buyer": "QIB",
    "EMPLOYEE": "EMP",
    "Shareholder": "SHA",
    "Policy Holder": "POL",
    "Non Institutional Bidder(NIB)": "NIB",
    "Qualified Institutional Buyer(QIB)": "QIB"
};
const CATEGORY_NAME_SHORT = {
    "Retail": 'Retail',
    "NIB": "Non Institutional Bidder(NIB)",
    "QIB": "Qualified Institutional Buyer(QIB)",
    "EMP": "EMPLOYEE",
    "SHA": "Shareholder",
    "POL": "Policy Holder"
};

//Azeem K :27-04-2024:logged out user if session is expired --Start
const API_FAILURE_MESSAGES = {
    INVALID_SESSION: 'INVALID SESSION',
    SESSION_DATA_NOT_RECEIVED: 'SESSION DATA NOT RECEIVED',
    USER_NOT_AUTHORIZED: 'THE USER IS NOT AUTHORIZED',
    SESSION_ID_NOT_AVAILABLE: 'SESSION ID NOT AVAILABLE'
};
//Azeem K :27-04-2024:logged out user if session is expired --End
const IS_MULTILEG_ALLOWED = true; // set true to show multileg everywhere - Parshva S - 25/04/2024


const productDetails = {
    productName: 'BREEZE'
};

const COVER = {
    TDES: "1234567890",
    AES: "11111111111111111111111111111111",
    AESIV: "1111111111111111",
    APP_SYNC_DETAILS: "ftil@1234"
};


/*Both below values should be change w.r.t to date on which build is getting made ---Start */

//const buildVersion = '01.10.24';
//const buildDate = '01/10/2024';

/* Both above values should be change w.r.t to date on which build is getting made---End */

// Ajitesh 24-07-2024 Multi Leg order related constants start
const MULTI_LEG = {
    ORDER_MAX_LEGS: 3,
    DUPLICATE_SCRIP_UPDATE: "Scrip already selected. Kindly select another scrip.",
    ADD_NEW_LEG: "add_new_leg",
    UPDATE_EXISTING_LEG: "update_existing_leg"
};
// Ajitesh 24-07-2024 Multi Leg order related constants end

// AJitesh 08-08-2024 Settings enable/disable totp
const SETTINGS_ENABLE_DISABLE_TOTP = {
    ENABLED_TOTP_SUCCESS_MESSAGE: "TOTP setting enabled successfully",
    ASK_DISABLE_TOTP: "Do you want to disable TOTP?"
};

// Hari k;27-09-2024:message-hub-start
const MESSAGE_HUB = {
    USER_TYPE: "R",
    DEVICE_TYPE: 'android',
    SITEMPLATE: "DIET",
    RECORD_COUNT: 25
};
// Hari k;27-09-2024:message-hub-end
const FILTER_DISPLAY_OPTIONS = {
    Exchange_Type: 'Exchange',
    Product_Type: 'Product Type',
    orderType: 'Order Type',
    order_status: 'Order Status'
};
//Breeze16-OrderSlicing :ManasaB : 11-10-2024 :  Using global varaible for layout type - Start
const LAYOUT_TYPE = {
    HORIZONTAL: 'horizontal',
    VERTICAL: 'vertical'
};
//Breeze16-OrderSlicing :ManasaB : 11-10-2024 :  Using global varaible for layout type - End

// Hari :14-10-2024: paths
const LOCATIONS = {
    PORTFOLIO: '/portfolio',
    WATCHLIST: '/watchlist',
    DASHBOARD: '/dashboard',
    ORDERS: '/orders',
    RECOMMENDATIONS: '/recommendations',
    CHART: '/chart',
    HEALTHCHECK: '/healthcheck'
};

const PROFIT_GROUP = {
    ONE: 1.00,
    TWO: 2.00,
    ZERO: 0.00,
};
const LOSS_GROUP = {
    MINUS_ONE: -1,
    MINUS_TWO: -2,
    MINUS_THREE: -3
};
const HEATMAP_COLURS = {
    GRAY: '#b1b1b1',
    GREEN: '#345c36',
    FERN_GREEN: '#417d44',
    FRUIT_SALAD: '#4caf50',
    RED_DAREN: '#d32f2f',
    RED: '#b8292a',
    MANCHESTER_NIGHTS: '#9b2120',
};

const CHART_OPEN_MODE = {
    OVERVIEW: "overview",
    SIDETRAY: "sidetray"
};

const DISCLAIMER_NOTE = {
    "forgotmpin": "The new MPIN should be different from last 5 MPIn's. If the entered MPIN does not meet this criterion then the entire process will be reinitiated with a new OTP.",
    "forgotpassword": "The new PASSWORD should be different from last 5 PASSWORd's. If the entered PASSWORD does not meet this criterion then the entire process will be reinitiated with a new OTP."
};



const DEFAULT_MANAGE_COLUMN_PROFILE_NAME = {
    WATCHLIST: 'WATCHLIST_PROFILE1',
    HOLDINGS: 'HOLDINGS_PROFILE',
    CONSTITUENT: 'CONSTITUENT_PROFILE',
    ORDER_BOOK_SIP: 'ORDER_BOOK_SIP_PROFILE',
    ORDER_GTD: "ORDER_GOOD_TILL_DATE_PROFILE",
    ORDER_GTT: "ORDER_GOOD_TILL_TRIGGER_PROFILE",
    ORDER_SPREAD: "ORDER_SPREAD_PROFILE",
    ORDER_SINGLE: "ORDER_SINGLE_SCRIP_PROFILE",
    ORDER_MULTI_SCRIPS: "ORDER_MULTI_SCRIP_PROFILE",
    NETPOSITION: "NETPOSITION_PROFILE",
    FUTURES: "FUTURES_PROFILE"
};

// Deepti b. BT-107398 [18/11/2024]: By default height and width for scrip popover on click of heatmap tile
const HEATMAP_POPOVER = {
    POPOVER_BYDEFAULT_WIDTH: 260,
    POPOVER_BYDEFAULT_HEIGHT: 117,
};

const GTD_DAYS_FOR_NCDEX = {
    MAX_DAYS: 6,
    DEFAULT_DATE: 6
};

const NET_POSITION_EXPIRY = {
    DAILY: 'DAILY',
    EXPIRY: 'EXPIRY'
};

const VOLUNTARY_BLOCK_TITLE = "Voluntary Block Online Access";  // Deepti b. BT-144474 [06/01//2025]: Title for voluntary block online access


const SURV_MEASURE_POPUP_ACTION = {
    YES: 1,
    NO: 0
};

const TRADING_NOT_ALLOWED_MSG = "You are currently not allowed to place/modify/cancel order in this segment";
const TRADING_NOT_ALLOWED_MSG_BASKET = "You are currently not allowed to place/modify/cancel order in the following segment(s):"; //BREEZE-8190 : Basket Order Recommendation : ManasaB : 26-08-2025


const HAMBURGER_LIST = {
    SSO_LINKS: 'SSO_LINKS',
    EXCHANGE_LINKS: 'EXCHANGE_LINKS'
};

const LOGIN_ERROR = {
    INVALID_USER: 'INVALID_USER',
    APP_INFO_FAILURE: 'APP_INFO_FAILURE'
};

const HIDE_FEATURES = false;
const SIP_ORDER_BY_OPTIONS = {
    QUANTITY: "Quantity",
    VALUE: "Value"
};

const APP_INFO_DEFAULT_VALUES = {
    APP_WATCHLIST_SCRIP_DEFAULT_COUNT: 50,
    APPLE_ID: 'https://apps.apple.com/',
    PLAY_STORE_LINK: "https://play.google.com/store",
    DEVTOOL_MESG: "Kindly close the devtools to use the app.",
    VERSION_NUMBER: API_SOURCE.VERSION, //Added app version number
    DEFAULT_SOCKET_RECONNECTION_RETRY_COUNT: -1,
    DEFAULT_ATOM_MINIMUM_AMOUNT: 50,
    FUND_MAX_AM: {
        "add": parseFloat(Number.POSITIVE_INFINITY),
        "add_NB": parseFloat(Number.POSITIVE_INFINITY),
        "transfer": "100000",
        "withdraw": ""
    },
    T2T_SCRIPT_ERROR_MESSAGE: 'You are placing order in Trade to trade Scrip and Intraday square off is not allowed.',
    BANNED_SCRIP_ERROR_MSG: "Security is in banned list, do you want to place order?",
    HOTPURSUIT_SCRIP_COUNT: "10",
    PORTFOLIO_ANALYZER_DATA: {},
    MINIMUM_INTERVAL_TIME_FOR_WHATSHOTDATA_CALL: 10,
    MAX_USER_DETAILS_LIST: 5,
    QR_LOGIN_TIMER: 2,
    OTP_RESEND_TIMER: 180,
    INVALID_OTP_ATTEMPTS: 5,
    ATOM_VALUE_HEADER: "UP|SMSUPI|",
    EKYC_INFO: {},
    SCRIPS_BATCH_COUNT: 15,
    REGISTER_USERLANDINGPAGE_BREEZE: 0,
    APP_MAX_PROFILE_COUNT: 15
};

const EQUITY_SERIES_LIST = [
    "EQ",  // Equity - normal delivery & intraday
    "BE",  // Book Entry - delivery only (T2T)
    "BZ",  // Surveillance T2T
    "BT",  // Illiquid - periodic call auction
    "BL",  // Block deal segment
    "GS",  // Government securities
    "N1", "N2", "N3",  // NCD series (can continue up to Nxx)
    "P1", "P2",        // Preference shares
    "W1", "W2",        // Warrants
    "RE",             // Rights entitlement
    "RR",             // Rights entitlement (alternative code)
    "SM",             // SME platform equities
    "IL",             // Institutional segment
    "MT",             // Mutual fund segment
    "X", "XT", "XD",   // Low-liquidity or special series
    "T0",             // Trade-to-Trade (T0) equity segment
    "A",              // Most liquid & compliant stocks (BSE)
    "B",              // Regular stocks (BSE, includes B1, B2 historically)
    "T",              // Trade-to-Trade (BSE)
    "Z",              // Non-compliant companies (BSE)
    "P",              // Preference shares (BSE)
    "F",              // Fixed income securities (BSE)
    "G",              // Government securities (BSE)
    "W",              // Warrants (BSE)
    "R",              // Rights entitlement (BSE)
    "X1", "X2",       // Extended liquid stocks (low or special trading conditions)
    "Y1", "Y2",       // Extended special segments (low liquidity or special criteria)
    "S1", "S2",       // Special category stocks (e.g., riskier, or speculative)
    "C",              // Convertible securities
    "D",              // Debenture series
    "F1", "F2",       // Fixed income or bond series
    "L",              // Listing new shares or special issue shares
    "I",              // Initial Public Offer (IPO) segment
    "V",              // Variable interest entities (special rights/shares)
    "M",              // Miscellaneous shares (often used for high-risk assets)
    "H",              // High-risk or volatility stocks
    "T0",
];

const MESSAGE_SOCKET_MSG_TYPE = {
    OMEX_MESSAGETYPE_ORDER: "ORD_NRML",
    OMEX_MESSAGETYPE_GTD_ORDER: "GTD_ORD_NRML",
    OMEX_MESSAGETYPE_TRADE: "TRD_MSG",
    OMEX_MESSAGETYPE_CHAT: "CHAT_MSG",
    OMEX_MESSAGETYPE_POS_CONV: "POS_CONV",
    OMEX_MESSAGETYPE_ALERT: "USR_ALERT",
    OMEX_MESSAGETYPE_MKTSTAT: "MKT_STAT",
    OMEX_MESSAGETYPE_REDISSTAT: "REDIS_STAT",
};

export {
    APP_INFO_DEFAULT_VALUES,
    EQUITY_SERIES_LIST,
    SIP_ORDER_BY_OPTIONS,
    MARKET_STATUS,
    HIDE_FEATURES,
    LOGIN_ERROR,
    HAMBURGER_LIST,
    DEFAULT_MANAGE_COLUMN_PROFILE_NAME,
    DISCLAIMER_NOTE,
    MESSAGE_HUB,
    LOCATIONS,
    HEATMAP_COLURS,
    PROFIT_GROUP,
    LOSS_GROUP,
    productDetails,
    PLACE_BID,
    MODIFY_BID,
    MIN_LOT,
    MAX_LOT_VALUE,
    MIN_LOT_VALUE,
    CUSTOM_BID,
    MAX_LOT,
    DEEP_LINK,
    MANAGE_COLUMNS_VIEW_TYPES,
    DONT_MISS_WATCHLIST_NAME,
    MY_HOLDINGS_WATCHLIST_NAME,
    BUSINESS_LAYER_RESPONSE,
    APPLICATION_TYPE,
    setStrSearch,
    strSearch,
    LOCAL_STORAGE_KEYS,
    SIDE_TRAY_EXPAND_PERCENTAGE,
    CALL_AUCTION,
    SPECIAL_PREOPEN,
    GSMVALUE,
    EXCHANGE_NAME_NOTIFICATION,
    DASHBOARD_EXPLORE_CATEGORY,
    EXCHANGE_NAME_API,
    MARKET_SEGMENT_ID,
    MAPPED_MARKET_SEGMENT_ID,
    MUTUALFUND_WATCHLIST_TABS_MENUS,
    ALL_ORDERS_STATUS,
    MPIN_INPUT_CLASSES,
    GLOBAL_SEARCH_PAGES,
    MAX_SEARCH_SCRIP_PER_PAGE,
    MAX_SEARCH_MF_SCRIP_PER_PAGE,
    MARKETDEPTH_INDEX,
    WATCHLIST_GRID_INDEX,
    LOGIN_SESSION_NUMBER,
    API_ERRORS,
    BEST5_INDEX,
    BCAST_MSG_CODE,
    TL_INDEX,
    MULTIPLIER,
    WATCHLIST_VIEW_MENU,
    GLOBAL_SEARCH_MIN_LENGTH,
    SIDEMENU,
    HEALTHSCORE_DESC,
    WATCHLIST_TABS_MENUS,
    NETWORK_RESPONSE_STATUS,
    API_CODES,
    MAX_WATCHLISTS,
    MAX_SCRIPS_IN_WATCHLISTS,
    MIN_SCRIPS_IN_WATCHLISTS,
    TOAST_TIMER,
    API_RESPONSE_STATUS,
    FUNDS_CONFIG_KEYS,
    APP_INFO,
    FORGOT_PASSWORD_SESSION_NUMBER,
    FORGOT_USER_ID_SESSION_NUMBER,
    FORGOT_MPIN_SESSION_NUMBER,
    GUEST_LOGIN_SESSION_NO,
    VALIDITY_TYPES,
    GUEST_MODE_TRIAL_DAYS,
    API_SOURCE,
    //PrachiTawde : 05-05-2023 : BT-107252 -  Breeze – Rate us & Feedback - Start
    APP_INFO_PARAMS,
    //PrachiTawde : 05-05-2023 : BT-107252 -  Breeze – Rate us & Feedback - End
    WALKTHROUGH_POPOVER,
    DASHBOAR_WALKTHROUGH_POPOVER_SEQUENCE,
    // GOOGLE_PLAYSTORE_ID,
    //abhijeetvarude : 12-05-2023 : convert one dimentional data to multidimentional - start
    INDICES_CONSTANTS,
    CONSTITUENTS_GRID_INDEX,

    //abhijeetvarude : 12-05-2023 : convert one dimentional data to multidimentional - end
    API_ENCRYPTION_METHODS,
    SCRIP_INSTRUMENTS,
    SUPPORT_RESISTANCE_VIEW,
    ORDER_TYPES,
    APP_AVG_BUY_PRICE,
    MF_WATCHLIST_GRID_INDEX,
    SIP_EXCEL_FILE_NAME,
    ORDERS_TABKEY,
    DECIMAL_LOCATOR, //By HiralK : 05-08-2023 - Decimal Locator Optimization
    //Maaz A : 15-06-2023 : BT-102298 - Breeze - Single Scrip Order entry - Start
    MSG_MASTER,
    ORDER_ENTRY_BUTTON_TOGGLE,
    ORDER_VALIDITY,
    ORDER_PRODUCT_TYPES_VALUES,
    ORDER_ENTRY_TYPES,
    MARGIN_PARAMS_DPR_FLAG,
    ORDER_ENTRY_QTY_DEFAULT_VALUES,
    //Maaz A : 15-06-2023 : BT-102298 - Breeze - Single Scrip Order entry - End
    DELETE_ALERT_STEP,
    ORDER_PRODUCT_TYPES,
    CONFIRMATION_TYPES,
    DEFAULT_APP_EKYC_INFO,
    MARKET_MOVEMENT,
    GRID_VIEW,
    ORDER_ENTRY_IS_BANNED_SCRIP_STATUS,
    SORT_TYPES,
    ALERT_STATUS,
    SUCCESSFULL_DELETE_ALERET_MESSAGE,
    GLOBAL_SEARCH_SCRIPS,
    DYANMIC_URL_CONSTANTS,
    //BT-96728 - Global Search Feature : ManasaB : 20/07/2023 - Start
    RECENT_SEARCH_LENGTH,
    EXPAND_RECENT_SEARCH_LENGTH,
    //BT-96728 - Global Search Feature : ManasaB : 20/07/2023 - End
    //HiralK : 01-08-2023 : Client Facility Template - Start
    FACILITY_NUM,
    FACILITY_STR,
    FACILITY_BOOL,
    ORDER_ENTRY_CONSTANTS,
    LOGIN_CONSTANTS,
    CATEGORY_NAME_SHORT,
    //HiralK : 01-08-2023 : Client Facility Template - End
    RECOMMENDATIONS,
    THEME_TYPE,
    SET_ALERT_FIELDS,
    DEFAULT_FAVOURITE_INDICES,
    DISPLAY_EXCHANGE_NAME,
    EXCHANGE_TYPES,
    MKT_SEGMENTID_HAVING_LOTS,
    SCREENERS_TABS,
    FREQUENCY_TYPE,
    MONTHLY_SIP_OPTIONS,
    ROUTES,
    GLOBAL_SEARCH_TABS, //Added as per comments from Maaz during PR : Manasa B : 25/08/2023
    PEER_COMPARISON,
    ANNUAL_REPORT,
    DASHBOARD_MENUS,
    LINK_OPEN_MODES,
    CONTENT_USER_MODES,
    POSITION_TYPES,
    INLINE_SEARCH_MAX_SEARCH_SCRIP_PER_PAGE,
    EXCHANGE_NAME_SCREENERS,
    NEWS_CMOT_MODE,
    MF_MAIN_TABS,
    MF_MY_CORNER_TABS,
    ORDERBOOK_API_ORDER_STATUS,
    AXIOS,
    CONTRACT_TYPES,
    EXPIRY_TYPES,
    LOGIN_ERROR_MSG,
    AUTO_LOCK_TIME,//Ravi R : 07-08-205 : BREEZE-9399 : Autolock
    SEGMENT_CASH,
    DEPOSITORY_CDSL,
    DEPOSITORY_NSDL,
    LIVE_PULSE_TABS,
    ALL_INDICES_SECTORS,
    MESSAGE_HUB_CHIPS, // Hari K : 07-11-2023 : SAT-109371 : Message Hub – variables
    FUNDS,// Hari K:20-11-2023:BT-119138 :Funds-View
    FUNDS_DEFAULT_INPUT_LENGTH,
    PRODUCT_DETAILS,
    HAMBURGER_MENU_ITEM_ID,
    FIBONACCI_TREND, //ManasaB : 21/11/2023 : BT-115296 Calculator Bug Fixing
    FIBONACCI_RETREACEEXT,
    EXCHANGE_NAME_LIVEPULSE,
    //Prachi T :BT-107377 - 17-11-2023 ScripInnfo recommendations - Start
    MARKET_OVERVIEW_TABS,
    FONT_SIZE,
    //Prachi T :BT-107377 - 17-11-2023 ScripInnfo recommendations - End
    SETTING_TABS,//Prachi T - 27-11-2023 - BT-110050 - Breeze- Settings Preferences
    ORDERS_LIMIT_IN_API,//Azeem K : 07-12-2023 :BT-101818 : Order Book - Single Scrip Order
    ORDER_STATUS_FROM_RESPONSE,
    ORDER_DISPLAY_STATUS,
    EDIS_PERMISSION_MESSAGE,
    EDIS_REVOKE_NETNET_PAGE,
    FIRST_LOGIN_EDIS_PERMISSION_MESSAGE_BODY,
    clsConstants,
    analysisIndices,
    historicRecords,
    historicYears,
    NOT_INCLUDED_GROUPS,
    COUNTS,
    SCRENNERS_KEYS,
    CATEGORY_NAME,
    API_FAILURE_MESSAGES,
    IS_MULTILEG_ALLOWED,
    IPO_CODE,
    COVER,
    EQUITY_SCREENERS,
    EQUITY_DERV_SCREENERS,
    EQUITY_CUR_SCREENERS,
    DERV_CUR_SCREENERS,
    DERV_CUR_COMMODITY_SCREENERS,
    ALL_COMBINED_SCREENERS,
    ALERT_VERSION,
    EDIS_SEARCH_ID,
    WATCHLIST_SEARCH_ID,
    MULTI_LEG,
    SETTINGS_ENABLE_DISABLE_TOTP,
    EDIS_MODES,
    FILTER_DISPLAY_OPTIONS,
    NetNetPGQSMode,
    EDIS_REVOKE_DESCLAIMER,
    CRORE,
    LAYOUT_TYPE,
    SESSION_STORAGE_KEYS,
    CHART_OPEN_MODE,
    HEATMAP_POPOVER,
    GTD_DAYS_FOR_NCDEX,
    NET_POSITION_EXPIRY,
    VOLUNTARY_BLOCK_TITLE,
    SURV_MEASURE_POPUP_ACTION,
    IPO_TYPE,
    IPO_TABS,
    ORDERBOOK_TABS,
    IPO_MODALS,
    ALERT_CATEGORIES,
    PAYTM,
    PAYU,
    GENERATE_TPIN_TEXT,
    GENERATE_TPIN_FAILURE_TEXT,
    REVOKE_TAB,
    LANDING_PAGE,
    LANDING_PAGE_INDEX,
    ARR_ORDER_TYPES,
    OPTION_TYPES,
    RECOMMENDATION_TABS,
    MESSAGE_SOCKET_MSG_TYPE,
    ORDER_ENTRY_BUY_SELL_TEXT,
    CAUTIONARY_TRANSACTION_TYPE,
    IPO_CATEGORY,
    TRADING_NOT_ALLOWED_MSG,
    TRADING_NOT_ALLOWED_MSG_BASKET,
    NET_POSITION_SEGMENT_TYPES,
    GRID_CONTEXT,
    SME_IPO_MIN_LOT,
    PNBHOLD_BANKID
};
